/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TaskInventoryRouteImport } from './routes/task-inventory'
import { Route as PrivasiRouteImport } from './routes/privasi'
import { Route as PilihDesaRouteImport } from './routes/pilih-desa'
import { Route as ParkirRouteImport } from './routes/parkir'
import { Route as NarasiRouteImport } from './routes/narasi'
import { Route as LoginRouteImport } from './routes/login'
import { Route as CompleteProfileRouteImport } from './routes/complete-profile'
import { Route as StaffRouteRouteImport } from './routes/staff/route'
import { Route as PlatformRouteRouteImport } from './routes/platform/route'
import { Route as DevRouteRouteImport } from './routes/dev/route'
import { Route as DashboardRouteRouteImport } from './routes/dashboard/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as PlatformIndexRouteImport } from './routes/platform/index'
import { Route as DevIndexRouteImport } from './routes/dev/index'
import { Route as DashboardIndexRouteImport } from './routes/dashboard/index'
import { Route as WargaPilihDesaRouteImport } from './routes/warga/pilih-desa'
import { Route as VerifyKodeRouteImport } from './routes/verify/$kode'
import { Route as PlatformWorkersRouteImport } from './routes/platform/workers'
import { Route as PlatformWhatsappServerRouteImport } from './routes/platform/whatsapp-server'
import { Route as PlatformTiketRouteImport } from './routes/platform/tiket'
import { Route as PlatformPenggunaRouteImport } from './routes/platform/pengguna'
import { Route as PlatformPengaturanRouteImport } from './routes/platform/pengaturan'
import { Route as PlatformPanduanRouteImport } from './routes/platform/panduan'
import { Route as PlatformLogAktivitasRouteImport } from './routes/platform/log-aktivitas'
import { Route as PlatformIntegrasiDesaRouteImport } from './routes/platform/integrasi-desa'
import { Route as DevWaRepairBudgetRouteImport } from './routes/dev/wa-repair-budget'
import { Route as DevObservabilityRouteImport } from './routes/dev/observability'
import { Route as DevHandlerEvolutionRouteImport } from './routes/dev/handler-evolution'
import { Route as DevFileHealthRouteImport } from './routes/dev/file-health'
import { Route as DevDocsRouteImport } from './routes/dev/docs'
import { Route as DevDbSchemaRouteImport } from './routes/dev/db-schema'
import { Route as DevCodeGraphRouteImport } from './routes/dev/code-graph'
import { Route as DevApiKeysRouteImport } from './routes/dev/api-keys'
import { Route as DevAiRoutingRouteImport } from './routes/dev/ai-routing'
import { Route as DevAiFlowRouteImport } from './routes/dev/ai-flow'
import { Route as DevAgentSwarmRouteImport } from './routes/dev/agent-swarm'
import { Route as WargaSlugRouteRouteImport } from './routes/warga/$slug/route'
import { Route as PlatformDesaRouteRouteImport } from './routes/platform/desa/route'
import { Route as DashboardDesaRouteRouteImport } from './routes/dashboard/desa/route'
import { Route as PlatformDesaIndexRouteImport } from './routes/platform/desa/index'
import { Route as DesaSlugIndexRouteImport } from './routes/desa/$slug/index'
import { Route as DashboardDesaIndexRouteImport } from './routes/dashboard/desa/index'
import { Route as DesaSlugVerifikasiKtpRouteImport } from './routes/desa/$slug/verifikasi-ktp'
import { Route as DesaSlugTransparansiRouteImport } from './routes/desa/$slug/transparansi'
import { Route as DesaSlugOverviewRouteImport } from './routes/desa/$slug/overview'
import { Route as DesaSlugBookingRouteImport } from './routes/desa/$slug/booking'
import { Route as PlatformDesaDesaIdRouteRouteImport } from './routes/platform/desa/$desaId/route'
import { Route as DesaSlugWargaRouteRouteImport } from './routes/desa/$slug/warga/route'
import { Route as DesaSlugLaporanRouteRouteImport } from './routes/desa/$slug/laporan/route'
import { Route as DesaSlugDashboardRouteRouteImport } from './routes/desa/$slug/dashboard/route'
import { Route as PlatformDesaDesaIdIndexRouteImport } from './routes/platform/desa/$desaId/index'
import { Route as DesaSlugWargaIndexRouteImport } from './routes/desa/$slug/warga/index'
import { Route as DesaSlugLaporanIndexRouteImport } from './routes/desa/$slug/laporan/index'
import { Route as DesaSlugDashboardIndexRouteImport } from './routes/desa/$slug/dashboard/index'
import { Route as PlatformDesaDesaIdToolsRouteImport } from './routes/platform/desa/$desaId/tools'
import { Route as PlatformDesaDesaIdTestAiRouteImport } from './routes/platform/desa/$desaId/test-ai'
import { Route as PlatformDesaDesaIdTemplateSuratRouteImport } from './routes/platform/desa/$desaId/template-surat'
import { Route as PlatformDesaDesaIdSuratRouteImport } from './routes/platform/desa/$desaId/surat'
import { Route as PlatformDesaDesaIdStatistikRouteImport } from './routes/platform/desa/$desaId/statistik'
import { Route as PlatformDesaDesaIdStaffRouteImport } from './routes/platform/desa/$desaId/staff'
import { Route as PlatformDesaDesaIdRiwayatRouteImport } from './routes/platform/desa/$desaId/riwayat'
import { Route as PlatformDesaDesaIdProfilDesaRouteImport } from './routes/platform/desa/$desaId/profil-desa'
import { Route as PlatformDesaDesaIdPertanahanRouteImport } from './routes/platform/desa/$desaId/pertanahan'
import { Route as PlatformDesaDesaIdPercakapanRouteImport } from './routes/platform/desa/$desaId/percakapan'
import { Route as PlatformDesaDesaIdPengaturanRouteImport } from './routes/platform/desa/$desaId/pengaturan'
import { Route as PlatformDesaDesaIdPengantarWilayahRouteImport } from './routes/platform/desa/$desaId/pengantar-wilayah'
import { Route as PlatformDesaDesaIdPendidikanRouteImport } from './routes/platform/desa/$desaId/pendidikan'
import { Route as PlatformDesaDesaIdPemilihanRouteImport } from './routes/platform/desa/$desaId/pemilihan'
import { Route as PlatformDesaDesaIdPembangunanRouteImport } from './routes/platform/desa/$desaId/pembangunan'
import { Route as PlatformDesaDesaIdPanduanRouteImport } from './routes/platform/desa/$desaId/panduan'
import { Route as PlatformDesaDesaIdMusrenbangRouteImport } from './routes/platform/desa/$desaId/musrenbang'
import { Route as PlatformDesaDesaIdMemoryRouteImport } from './routes/platform/desa/$desaId/memory'
import { Route as PlatformDesaDesaIdLogAktivitasRouteImport } from './routes/platform/desa/$desaId/log-aktivitas'
import { Route as PlatformDesaDesaIdLifeEventsRouteImport } from './routes/platform/desa/$desaId/life-events'
import { Route as PlatformDesaDesaIdLaporanRouteImport } from './routes/platform/desa/$desaId/laporan'
import { Route as PlatformDesaDesaIdKeuanganRouteImport } from './routes/platform/desa/$desaId/keuangan'
import { Route as PlatformDesaDesaIdKetertibanRouteImport } from './routes/platform/desa/$desaId/ketertiban'
import { Route as PlatformDesaDesaIdKesehatanRouteImport } from './routes/platform/desa/$desaId/kesehatan'
import { Route as PlatformDesaDesaIdKepribadianAiRouteImport } from './routes/platform/desa/$desaId/kepribadian-ai'
import { Route as PlatformDesaDesaIdKependudukanRouteImport } from './routes/platform/desa/$desaId/kependudukan'
import { Route as PlatformDesaDesaIdKepegawaianRouteImport } from './routes/platform/desa/$desaId/kepegawaian'
import { Route as PlatformDesaDesaIdKelembagaanRouteImport } from './routes/platform/desa/$desaId/kelembagaan'
import { Route as PlatformDesaDesaIdJabatanRouteImport } from './routes/platform/desa/$desaId/jabatan'
import { Route as PlatformDesaDesaIdInformasiRouteImport } from './routes/platform/desa/$desaId/informasi'
import { Route as PlatformDesaDesaIdEkonomiRouteImport } from './routes/platform/desa/$desaId/ekonomi'
import { Route as PlatformDesaDesaIdDraftSuratRouteImport } from './routes/platform/desa/$desaId/draft-surat'
import { Route as PlatformDesaDesaIdDokumenRouteImport } from './routes/platform/desa/$desaId/dokumen'
import { Route as PlatformDesaDesaIdCustomToolsRouteImport } from './routes/platform/desa/$desaId/custom-tools'
import { Route as PlatformDesaDesaIdChannelRouteImport } from './routes/platform/desa/$desaId/channel'
import { Route as PlatformDesaDesaIdBookingRouteImport } from './routes/platform/desa/$desaId/booking'
import { Route as PlatformDesaDesaIdBencanaRouteImport } from './routes/platform/desa/$desaId/bencana'
import { Route as PlatformDesaDesaIdBansosRouteImport } from './routes/platform/desa/$desaId/bansos'
import { Route as PlatformDesaDesaIdAgenRouteImport } from './routes/platform/desa/$desaId/agen'
import { Route as PlatformDesaDesaIdAdministrasiRouteImport } from './routes/platform/desa/$desaId/administrasi'
import { Route as DesaSlugWargaSuratRouteImport } from './routes/desa/$slug/warga/surat'
import { Route as DesaSlugWargaProfilRouteImport } from './routes/desa/$slug/warga/profil'
import { Route as DesaSlugWargaLoginRouteImport } from './routes/desa/$slug/warga/login'
import { Route as DesaSlugWargaLifeEventsRouteImport } from './routes/desa/$slug/warga/life-events'
import { Route as DesaSlugWargaLaporanRouteImport } from './routes/desa/$slug/warga/laporan'
import { Route as DesaSlugWargaChatRouteImport } from './routes/desa/$slug/warga/chat'
import { Route as DesaSlugWargaBookingRouteImport } from './routes/desa/$slug/warga/booking'
import { Route as DesaSlugLaporanIdRouteImport } from './routes/desa/$slug/laporan/$id'
import { Route as DesaSlugFormKodeRouteImport } from './routes/desa/$slug/form/$kode'
import { Route as DesaSlugDashboardToolsRouteImport } from './routes/desa/$slug/dashboard/tools'
import { Route as DesaSlugDashboardTestAiRouteImport } from './routes/desa/$slug/dashboard/test-ai'
import { Route as DesaSlugDashboardTemplateSuratRouteImport } from './routes/desa/$slug/dashboard/template-surat'
import { Route as DesaSlugDashboardSuratRouteImport } from './routes/desa/$slug/dashboard/surat'
import { Route as DesaSlugDashboardStatistikRouteImport } from './routes/desa/$slug/dashboard/statistik'
import { Route as DesaSlugDashboardStaffRouteImport } from './routes/desa/$slug/dashboard/staff'
import { Route as DesaSlugDashboardRiwayatRouteImport } from './routes/desa/$slug/dashboard/riwayat'
import { Route as DesaSlugDashboardProfilDesaRouteImport } from './routes/desa/$slug/dashboard/profil-desa'
import { Route as DesaSlugDashboardPertanahanRouteImport } from './routes/desa/$slug/dashboard/pertanahan'
import { Route as DesaSlugDashboardPercakapanRouteImport } from './routes/desa/$slug/dashboard/percakapan'
import { Route as DesaSlugDashboardPengaturanRouteImport } from './routes/desa/$slug/dashboard/pengaturan'
import { Route as DesaSlugDashboardPengantarWilayahRouteImport } from './routes/desa/$slug/dashboard/pengantar-wilayah'
import { Route as DesaSlugDashboardPendidikanRouteImport } from './routes/desa/$slug/dashboard/pendidikan'
import { Route as DesaSlugDashboardPemilihanRouteImport } from './routes/desa/$slug/dashboard/pemilihan'
import { Route as DesaSlugDashboardPembangunanRouteImport } from './routes/desa/$slug/dashboard/pembangunan'
import { Route as DesaSlugDashboardPanduanRouteImport } from './routes/desa/$slug/dashboard/panduan'
import { Route as DesaSlugDashboardMusrenbangRouteImport } from './routes/desa/$slug/dashboard/musrenbang'
import { Route as DesaSlugDashboardMemoryRouteImport } from './routes/desa/$slug/dashboard/memory'
import { Route as DesaSlugDashboardLogAktivitasRouteImport } from './routes/desa/$slug/dashboard/log-aktivitas'
import { Route as DesaSlugDashboardLifeEventsRouteImport } from './routes/desa/$slug/dashboard/life-events'
import { Route as DesaSlugDashboardLaporanRouteImport } from './routes/desa/$slug/dashboard/laporan'
import { Route as DesaSlugDashboardKeuanganRouteImport } from './routes/desa/$slug/dashboard/keuangan'
import { Route as DesaSlugDashboardKetertibanRouteImport } from './routes/desa/$slug/dashboard/ketertiban'
import { Route as DesaSlugDashboardKesehatanRouteImport } from './routes/desa/$slug/dashboard/kesehatan'
import { Route as DesaSlugDashboardKepribadianAiRouteImport } from './routes/desa/$slug/dashboard/kepribadian-ai'
import { Route as DesaSlugDashboardKependudukanRouteImport } from './routes/desa/$slug/dashboard/kependudukan'
import { Route as DesaSlugDashboardKepegawaianRouteImport } from './routes/desa/$slug/dashboard/kepegawaian'
import { Route as DesaSlugDashboardKelembagaanRouteImport } from './routes/desa/$slug/dashboard/kelembagaan'
import { Route as DesaSlugDashboardJabatanRouteImport } from './routes/desa/$slug/dashboard/jabatan'
import { Route as DesaSlugDashboardInformasiRouteImport } from './routes/desa/$slug/dashboard/informasi'
import { Route as DesaSlugDashboardEkonomiRouteImport } from './routes/desa/$slug/dashboard/ekonomi'
import { Route as DesaSlugDashboardDraftSuratRouteImport } from './routes/desa/$slug/dashboard/draft-surat'
import { Route as DesaSlugDashboardDokumenRouteImport } from './routes/desa/$slug/dashboard/dokumen'
import { Route as DesaSlugDashboardCustomToolsRouteImport } from './routes/desa/$slug/dashboard/custom-tools'
import { Route as DesaSlugDashboardChannelRouteImport } from './routes/desa/$slug/dashboard/channel'
import { Route as DesaSlugDashboardBookingRouteImport } from './routes/desa/$slug/dashboard/booking'
import { Route as DesaSlugDashboardBencanaRouteImport } from './routes/desa/$slug/dashboard/bencana'
import { Route as DesaSlugDashboardBansosRouteImport } from './routes/desa/$slug/dashboard/bansos'
import { Route as DesaSlugDashboardAgenRouteImport } from './routes/desa/$slug/dashboard/agen'
import { Route as DesaSlugDashboardAdministrasiRouteImport } from './routes/desa/$slug/dashboard/administrasi'

const TaskInventoryRoute = TaskInventoryRouteImport.update({
  id: '/task-inventory',
  path: '/task-inventory',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivasiRoute = PrivasiRouteImport.update({
  id: '/privasi',
  path: '/privasi',
  getParentRoute: () => rootRouteImport,
} as any)
const PilihDesaRoute = PilihDesaRouteImport.update({
  id: '/pilih-desa',
  path: '/pilih-desa',
  getParentRoute: () => rootRouteImport,
} as any)
const ParkirRoute = ParkirRouteImport.update({
  id: '/parkir',
  path: '/parkir',
  getParentRoute: () => rootRouteImport,
} as any)
const NarasiRoute = NarasiRouteImport.update({
  id: '/narasi',
  path: '/narasi',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const CompleteProfileRoute = CompleteProfileRouteImport.update({
  id: '/complete-profile',
  path: '/complete-profile',
  getParentRoute: () => rootRouteImport,
} as any)
const StaffRouteRoute = StaffRouteRouteImport.update({
  id: '/staff',
  path: '/staff',
  getParentRoute: () => rootRouteImport,
} as any)
const PlatformRouteRoute = PlatformRouteRouteImport.update({
  id: '/platform',
  path: '/platform',
  getParentRoute: () => rootRouteImport,
} as any)
const DevRouteRoute = DevRouteRouteImport.update({
  id: '/dev',
  path: '/dev',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRouteRoute = DashboardRouteRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const PlatformIndexRoute = PlatformIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PlatformRouteRoute,
} as any)
const DevIndexRoute = DevIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DevRouteRoute,
} as any)
const DashboardIndexRoute = DashboardIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const WargaPilihDesaRoute = WargaPilihDesaRouteImport.update({
  id: '/warga/pilih-desa',
  path: '/warga/pilih-desa',
  getParentRoute: () => rootRouteImport,
} as any)
const VerifyKodeRoute = VerifyKodeRouteImport.update({
  id: '/verify/$kode',
  path: '/verify/$kode',
  getParentRoute: () => rootRouteImport,
} as any)
const PlatformWorkersRoute = PlatformWorkersRouteImport.update({
  id: '/workers',
  path: '/workers',
  getParentRoute: () => PlatformRouteRoute,
} as any)
const PlatformWhatsappServerRoute = PlatformWhatsappServerRouteImport.update({
  id: '/whatsapp-server',
  path: '/whatsapp-server',
  getParentRoute: () => PlatformRouteRoute,
} as any)
const PlatformTiketRoute = PlatformTiketRouteImport.update({
  id: '/tiket',
  path: '/tiket',
  getParentRoute: () => PlatformRouteRoute,
} as any)
const PlatformPenggunaRoute = PlatformPenggunaRouteImport.update({
  id: '/pengguna',
  path: '/pengguna',
  getParentRoute: () => PlatformRouteRoute,
} as any)
const PlatformPengaturanRoute = PlatformPengaturanRouteImport.update({
  id: '/pengaturan',
  path: '/pengaturan',
  getParentRoute: () => PlatformRouteRoute,
} as any)
const PlatformPanduanRoute = PlatformPanduanRouteImport.update({
  id: '/panduan',
  path: '/panduan',
  getParentRoute: () => PlatformRouteRoute,
} as any)
const PlatformLogAktivitasRoute = PlatformLogAktivitasRouteImport.update({
  id: '/log-aktivitas',
  path: '/log-aktivitas',
  getParentRoute: () => PlatformRouteRoute,
} as any)
const PlatformIntegrasiDesaRoute = PlatformIntegrasiDesaRouteImport.update({
  id: '/integrasi-desa',
  path: '/integrasi-desa',
  getParentRoute: () => PlatformRouteRoute,
} as any)
const DevWaRepairBudgetRoute = DevWaRepairBudgetRouteImport.update({
  id: '/wa-repair-budget',
  path: '/wa-repair-budget',
  getParentRoute: () => DevRouteRoute,
} as any)
const DevObservabilityRoute = DevObservabilityRouteImport.update({
  id: '/observability',
  path: '/observability',
  getParentRoute: () => DevRouteRoute,
} as any)
const DevHandlerEvolutionRoute = DevHandlerEvolutionRouteImport.update({
  id: '/handler-evolution',
  path: '/handler-evolution',
  getParentRoute: () => DevRouteRoute,
} as any)
const DevFileHealthRoute = DevFileHealthRouteImport.update({
  id: '/file-health',
  path: '/file-health',
  getParentRoute: () => DevRouteRoute,
} as any)
const DevDocsRoute = DevDocsRouteImport.update({
  id: '/docs',
  path: '/docs',
  getParentRoute: () => DevRouteRoute,
} as any)
const DevDbSchemaRoute = DevDbSchemaRouteImport.update({
  id: '/db-schema',
  path: '/db-schema',
  getParentRoute: () => DevRouteRoute,
} as any)
const DevCodeGraphRoute = DevCodeGraphRouteImport.update({
  id: '/code-graph',
  path: '/code-graph',
  getParentRoute: () => DevRouteRoute,
} as any)
const DevApiKeysRoute = DevApiKeysRouteImport.update({
  id: '/api-keys',
  path: '/api-keys',
  getParentRoute: () => DevRouteRoute,
} as any)
const DevAiRoutingRoute = DevAiRoutingRouteImport.update({
  id: '/ai-routing',
  path: '/ai-routing',
  getParentRoute: () => DevRouteRoute,
} as any)
const DevAiFlowRoute = DevAiFlowRouteImport.update({
  id: '/ai-flow',
  path: '/ai-flow',
  getParentRoute: () => DevRouteRoute,
} as any)
const DevAgentSwarmRoute = DevAgentSwarmRouteImport.update({
  id: '/agent-swarm',
  path: '/agent-swarm',
  getParentRoute: () => DevRouteRoute,
} as any)
const WargaSlugRouteRoute = WargaSlugRouteRouteImport.update({
  id: '/warga/$slug',
  path: '/warga/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const PlatformDesaRouteRoute = PlatformDesaRouteRouteImport.update({
  id: '/desa',
  path: '/desa',
  getParentRoute: () => PlatformRouteRoute,
} as any)
const DashboardDesaRouteRoute = DashboardDesaRouteRouteImport.update({
  id: '/desa',
  path: '/desa',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const PlatformDesaIndexRoute = PlatformDesaIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PlatformDesaRouteRoute,
} as any)
const DesaSlugIndexRoute = DesaSlugIndexRouteImport.update({
  id: '/desa/$slug/',
  path: '/desa/$slug/',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardDesaIndexRoute = DashboardDesaIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DashboardDesaRouteRoute,
} as any)
const DesaSlugVerifikasiKtpRoute = DesaSlugVerifikasiKtpRouteImport.update({
  id: '/desa/$slug/verifikasi-ktp',
  path: '/desa/$slug/verifikasi-ktp',
  getParentRoute: () => rootRouteImport,
} as any)
const DesaSlugTransparansiRoute = DesaSlugTransparansiRouteImport.update({
  id: '/desa/$slug/transparansi',
  path: '/desa/$slug/transparansi',
  getParentRoute: () => rootRouteImport,
} as any)
const DesaSlugOverviewRoute = DesaSlugOverviewRouteImport.update({
  id: '/desa/$slug/overview',
  path: '/desa/$slug/overview',
  getParentRoute: () => rootRouteImport,
} as any)
const DesaSlugBookingRoute = DesaSlugBookingRouteImport.update({
  id: '/desa/$slug/booking',
  path: '/desa/$slug/booking',
  getParentRoute: () => rootRouteImport,
} as any)
const PlatformDesaDesaIdRouteRoute = PlatformDesaDesaIdRouteRouteImport.update({
  id: '/$desaId',
  path: '/$desaId',
  getParentRoute: () => PlatformDesaRouteRoute,
} as any)
const DesaSlugWargaRouteRoute = DesaSlugWargaRouteRouteImport.update({
  id: '/desa/$slug/warga',
  path: '/desa/$slug/warga',
  getParentRoute: () => rootRouteImport,
} as any)
const DesaSlugLaporanRouteRoute = DesaSlugLaporanRouteRouteImport.update({
  id: '/desa/$slug/laporan',
  path: '/desa/$slug/laporan',
  getParentRoute: () => rootRouteImport,
} as any)
const DesaSlugDashboardRouteRoute = DesaSlugDashboardRouteRouteImport.update({
  id: '/desa/$slug/dashboard',
  path: '/desa/$slug/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const PlatformDesaDesaIdIndexRoute = PlatformDesaDesaIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PlatformDesaDesaIdRouteRoute,
} as any)
const DesaSlugWargaIndexRoute = DesaSlugWargaIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DesaSlugWargaRouteRoute,
} as any)
const DesaSlugLaporanIndexRoute = DesaSlugLaporanIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DesaSlugLaporanRouteRoute,
} as any)
const DesaSlugDashboardIndexRoute = DesaSlugDashboardIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DesaSlugDashboardRouteRoute,
} as any)
const PlatformDesaDesaIdToolsRoute = PlatformDesaDesaIdToolsRouteImport.update({
  id: '/tools',
  path: '/tools',
  getParentRoute: () => PlatformDesaDesaIdRouteRoute,
} as any)
const PlatformDesaDesaIdTestAiRoute =
  PlatformDesaDesaIdTestAiRouteImport.update({
    id: '/test-ai',
    path: '/test-ai',
    getParentRoute: () => PlatformDesaDesaIdRouteRoute,
  } as any)
const PlatformDesaDesaIdTemplateSuratRoute =
  PlatformDesaDesaIdTemplateSuratRouteImport.update({
    id: '/template-surat',
    path: '/template-surat',
    getParentRoute: () => PlatformDesaDesaIdRouteRoute,
  } as any)
const PlatformDesaDesaIdSuratRoute = PlatformDesaDesaIdSuratRouteImport.update({
  id: '/surat',
  path: '/surat',
  getParentRoute: () => PlatformDesaDesaIdRouteRoute,
} as any)
const PlatformDesaDesaIdStatistikRoute =
  PlatformDesaDesaIdStatistikRouteImport.update({
    id: '/statistik',
    path: '/statistik',
    getParentRoute: () => PlatformDesaDesaIdRouteRoute,
  } as any)
const PlatformDesaDesaIdStaffRoute = PlatformDesaDesaIdStaffRouteImport.update({
  id: '/staff',
  path: '/staff',
  getParentRoute: () => PlatformDesaDesaIdRouteRoute,
} as any)
const PlatformDesaDesaIdRiwayatRoute =
  PlatformDesaDesaIdRiwayatRouteImport.update({
    id: '/riwayat',
    path: '/riwayat',
    getParentRoute: () => PlatformDesaDesaIdRouteRoute,
  } as any)
const PlatformDesaDesaIdProfilDesaRoute =
  PlatformDesaDesaIdProfilDesaRouteImport.update({
    id: '/profil-desa',
    path: '/profil-desa',
    getParentRoute: () => PlatformDesaDesaIdRouteRoute,
  } as any)
const PlatformDesaDesaIdPertanahanRoute =
  PlatformDesaDesaIdPertanahanRouteImport.update({
    id: '/pertanahan',
    path: '/pertanahan',
    getParentRoute: () => PlatformDesaDesaIdRouteRoute,
  } as any)
const PlatformDesaDesaIdPercakapanRoute =
  PlatformDesaDesaIdPercakapanRouteImport.update({
    id: '/percakapan',
    path: '/percakapan',
    getParentRoute: () => PlatformDesaDesaIdRouteRoute,
  } as any)
const PlatformDesaDesaIdPengaturanRoute =
  PlatformDesaDesaIdPengaturanRouteImport.update({
    id: '/pengaturan',
    path: '/pengaturan',
    getParentRoute: () => PlatformDesaDesaIdRouteRoute,
  } as any)
const PlatformDesaDesaIdPengantarWilayahRoute =
  PlatformDesaDesaIdPengantarWilayahRouteImport.update({
    id: '/pengantar-wilayah',
    path: '/pengantar-wilayah',
    getParentRoute: () => PlatformDesaDesaIdRouteRoute,
  } as any)
const PlatformDesaDesaIdPendidikanRoute =
  PlatformDesaDesaIdPendidikanRouteImport.update({
    id: '/pendidikan',
    path: '/pendidikan',
    getParentRoute: () => PlatformDesaDesaIdRouteRoute,
  } as any)
const PlatformDesaDesaIdPemilihanRoute =
  PlatformDesaDesaIdPemilihanRouteImport.update({
    id: '/pemilihan',
    path: '/pemilihan',
    getParentRoute: () => PlatformDesaDesaIdRouteRoute,
  } as any)
const PlatformDesaDesaIdPembangunanRoute =
  PlatformDesaDesaIdPembangunanRouteImport.update({
    id: '/pembangunan',
    path: '/pembangunan',
    getParentRoute: () => PlatformDesaDesaIdRouteRoute,
  } as any)
const PlatformDesaDesaIdPanduanRoute =
  PlatformDesaDesaIdPanduanRouteImport.update({
    id: '/panduan',
    path: '/panduan',
    getParentRoute: () => PlatformDesaDesaIdRouteRoute,
  } as any)
const PlatformDesaDesaIdMusrenbangRoute =
  PlatformDesaDesaIdMusrenbangRouteImport.update({
    id: '/musrenbang',
    path: '/musrenbang',
    getParentRoute: () => PlatformDesaDesaIdRouteRoute,
  } as any)
const PlatformDesaDesaIdMemoryRoute =
  PlatformDesaDesaIdMemoryRouteImport.update({
    id: '/memory',
    path: '/memory',
    getParentRoute: () => PlatformDesaDesaIdRouteRoute,
  } as any)
const PlatformDesaDesaIdLogAktivitasRoute =
  PlatformDesaDesaIdLogAktivitasRouteImport.update({
    id: '/log-aktivitas',
    path: '/log-aktivitas',
    getParentRoute: () => PlatformDesaDesaIdRouteRoute,
  } as any)
const PlatformDesaDesaIdLifeEventsRoute =
  PlatformDesaDesaIdLifeEventsRouteImport.update({
    id: '/life-events',
    path: '/life-events',
    getParentRoute: () => PlatformDesaDesaIdRouteRoute,
  } as any)
const PlatformDesaDesaIdLaporanRoute =
  PlatformDesaDesaIdLaporanRouteImport.update({
    id: '/laporan',
    path: '/laporan',
    getParentRoute: () => PlatformDesaDesaIdRouteRoute,
  } as any)
const PlatformDesaDesaIdKeuanganRoute =
  PlatformDesaDesaIdKeuanganRouteImport.update({
    id: '/keuangan',
    path: '/keuangan',
    getParentRoute: () => PlatformDesaDesaIdRouteRoute,
  } as any)
const PlatformDesaDesaIdKetertibanRoute =
  PlatformDesaDesaIdKetertibanRouteImport.update({
    id: '/ketertiban',
    path: '/ketertiban',
    getParentRoute: () => PlatformDesaDesaIdRouteRoute,
  } as any)
const PlatformDesaDesaIdKesehatanRoute =
  PlatformDesaDesaIdKesehatanRouteImport.update({
    id: '/kesehatan',
    path: '/kesehatan',
    getParentRoute: () => PlatformDesaDesaIdRouteRoute,
  } as any)
const PlatformDesaDesaIdKepribadianAiRoute =
  PlatformDesaDesaIdKepribadianAiRouteImport.update({
    id: '/kepribadian-ai',
    path: '/kepribadian-ai',
    getParentRoute: () => PlatformDesaDesaIdRouteRoute,
  } as any)
const PlatformDesaDesaIdKependudukanRoute =
  PlatformDesaDesaIdKependudukanRouteImport.update({
    id: '/kependudukan',
    path: '/kependudukan',
    getParentRoute: () => PlatformDesaDesaIdRouteRoute,
  } as any)
const PlatformDesaDesaIdKepegawaianRoute =
  PlatformDesaDesaIdKepegawaianRouteImport.update({
    id: '/kepegawaian',
    path: '/kepegawaian',
    getParentRoute: () => PlatformDesaDesaIdRouteRoute,
  } as any)
const PlatformDesaDesaIdKelembagaanRoute =
  PlatformDesaDesaIdKelembagaanRouteImport.update({
    id: '/kelembagaan',
    path: '/kelembagaan',
    getParentRoute: () => PlatformDesaDesaIdRouteRoute,
  } as any)
const PlatformDesaDesaIdJabatanRoute =
  PlatformDesaDesaIdJabatanRouteImport.update({
    id: '/jabatan',
    path: '/jabatan',
    getParentRoute: () => PlatformDesaDesaIdRouteRoute,
  } as any)
const PlatformDesaDesaIdInformasiRoute =
  PlatformDesaDesaIdInformasiRouteImport.update({
    id: '/informasi',
    path: '/informasi',
    getParentRoute: () => PlatformDesaDesaIdRouteRoute,
  } as any)
const PlatformDesaDesaIdEkonomiRoute =
  PlatformDesaDesaIdEkonomiRouteImport.update({
    id: '/ekonomi',
    path: '/ekonomi',
    getParentRoute: () => PlatformDesaDesaIdRouteRoute,
  } as any)
const PlatformDesaDesaIdDraftSuratRoute =
  PlatformDesaDesaIdDraftSuratRouteImport.update({
    id: '/draft-surat',
    path: '/draft-surat',
    getParentRoute: () => PlatformDesaDesaIdRouteRoute,
  } as any)
const PlatformDesaDesaIdDokumenRoute =
  PlatformDesaDesaIdDokumenRouteImport.update({
    id: '/dokumen',
    path: '/dokumen',
    getParentRoute: () => PlatformDesaDesaIdRouteRoute,
  } as any)
const PlatformDesaDesaIdCustomToolsRoute =
  PlatformDesaDesaIdCustomToolsRouteImport.update({
    id: '/custom-tools',
    path: '/custom-tools',
    getParentRoute: () => PlatformDesaDesaIdRouteRoute,
  } as any)
const PlatformDesaDesaIdChannelRoute =
  PlatformDesaDesaIdChannelRouteImport.update({
    id: '/channel',
    path: '/channel',
    getParentRoute: () => PlatformDesaDesaIdRouteRoute,
  } as any)
const PlatformDesaDesaIdBookingRoute =
  PlatformDesaDesaIdBookingRouteImport.update({
    id: '/booking',
    path: '/booking',
    getParentRoute: () => PlatformDesaDesaIdRouteRoute,
  } as any)
const PlatformDesaDesaIdBencanaRoute =
  PlatformDesaDesaIdBencanaRouteImport.update({
    id: '/bencana',
    path: '/bencana',
    getParentRoute: () => PlatformDesaDesaIdRouteRoute,
  } as any)
const PlatformDesaDesaIdBansosRoute =
  PlatformDesaDesaIdBansosRouteImport.update({
    id: '/bansos',
    path: '/bansos',
    getParentRoute: () => PlatformDesaDesaIdRouteRoute,
  } as any)
const PlatformDesaDesaIdAgenRoute = PlatformDesaDesaIdAgenRouteImport.update({
  id: '/agen',
  path: '/agen',
  getParentRoute: () => PlatformDesaDesaIdRouteRoute,
} as any)
const PlatformDesaDesaIdAdministrasiRoute =
  PlatformDesaDesaIdAdministrasiRouteImport.update({
    id: '/administrasi',
    path: '/administrasi',
    getParentRoute: () => PlatformDesaDesaIdRouteRoute,
  } as any)
const DesaSlugWargaSuratRoute = DesaSlugWargaSuratRouteImport.update({
  id: '/surat',
  path: '/surat',
  getParentRoute: () => DesaSlugWargaRouteRoute,
} as any)
const DesaSlugWargaProfilRoute = DesaSlugWargaProfilRouteImport.update({
  id: '/profil',
  path: '/profil',
  getParentRoute: () => DesaSlugWargaRouteRoute,
} as any)
const DesaSlugWargaLoginRoute = DesaSlugWargaLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => DesaSlugWargaRouteRoute,
} as any)
const DesaSlugWargaLifeEventsRoute = DesaSlugWargaLifeEventsRouteImport.update({
  id: '/life-events',
  path: '/life-events',
  getParentRoute: () => DesaSlugWargaRouteRoute,
} as any)
const DesaSlugWargaLaporanRoute = DesaSlugWargaLaporanRouteImport.update({
  id: '/laporan',
  path: '/laporan',
  getParentRoute: () => DesaSlugWargaRouteRoute,
} as any)
const DesaSlugWargaChatRoute = DesaSlugWargaChatRouteImport.update({
  id: '/chat',
  path: '/chat',
  getParentRoute: () => DesaSlugWargaRouteRoute,
} as any)
const DesaSlugWargaBookingRoute = DesaSlugWargaBookingRouteImport.update({
  id: '/booking',
  path: '/booking',
  getParentRoute: () => DesaSlugWargaRouteRoute,
} as any)
const DesaSlugLaporanIdRoute = DesaSlugLaporanIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => DesaSlugLaporanRouteRoute,
} as any)
const DesaSlugFormKodeRoute = DesaSlugFormKodeRouteImport.update({
  id: '/desa/$slug/form/$kode',
  path: '/desa/$slug/form/$kode',
  getParentRoute: () => rootRouteImport,
} as any)
const DesaSlugDashboardToolsRoute = DesaSlugDashboardToolsRouteImport.update({
  id: '/tools',
  path: '/tools',
  getParentRoute: () => DesaSlugDashboardRouteRoute,
} as any)
const DesaSlugDashboardTestAiRoute = DesaSlugDashboardTestAiRouteImport.update({
  id: '/test-ai',
  path: '/test-ai',
  getParentRoute: () => DesaSlugDashboardRouteRoute,
} as any)
const DesaSlugDashboardTemplateSuratRoute =
  DesaSlugDashboardTemplateSuratRouteImport.update({
    id: '/template-surat',
    path: '/template-surat',
    getParentRoute: () => DesaSlugDashboardRouteRoute,
  } as any)
const DesaSlugDashboardSuratRoute = DesaSlugDashboardSuratRouteImport.update({
  id: '/surat',
  path: '/surat',
  getParentRoute: () => DesaSlugDashboardRouteRoute,
} as any)
const DesaSlugDashboardStatistikRoute =
  DesaSlugDashboardStatistikRouteImport.update({
    id: '/statistik',
    path: '/statistik',
    getParentRoute: () => DesaSlugDashboardRouteRoute,
  } as any)
const DesaSlugDashboardStaffRoute = DesaSlugDashboardStaffRouteImport.update({
  id: '/staff',
  path: '/staff',
  getParentRoute: () => DesaSlugDashboardRouteRoute,
} as any)
const DesaSlugDashboardRiwayatRoute =
  DesaSlugDashboardRiwayatRouteImport.update({
    id: '/riwayat',
    path: '/riwayat',
    getParentRoute: () => DesaSlugDashboardRouteRoute,
  } as any)
const DesaSlugDashboardProfilDesaRoute =
  DesaSlugDashboardProfilDesaRouteImport.update({
    id: '/profil-desa',
    path: '/profil-desa',
    getParentRoute: () => DesaSlugDashboardRouteRoute,
  } as any)
const DesaSlugDashboardPertanahanRoute =
  DesaSlugDashboardPertanahanRouteImport.update({
    id: '/pertanahan',
    path: '/pertanahan',
    getParentRoute: () => DesaSlugDashboardRouteRoute,
  } as any)
const DesaSlugDashboardPercakapanRoute =
  DesaSlugDashboardPercakapanRouteImport.update({
    id: '/percakapan',
    path: '/percakapan',
    getParentRoute: () => DesaSlugDashboardRouteRoute,
  } as any)
const DesaSlugDashboardPengaturanRoute =
  DesaSlugDashboardPengaturanRouteImport.update({
    id: '/pengaturan',
    path: '/pengaturan',
    getParentRoute: () => DesaSlugDashboardRouteRoute,
  } as any)
const DesaSlugDashboardPengantarWilayahRoute =
  DesaSlugDashboardPengantarWilayahRouteImport.update({
    id: '/pengantar-wilayah',
    path: '/pengantar-wilayah',
    getParentRoute: () => DesaSlugDashboardRouteRoute,
  } as any)
const DesaSlugDashboardPendidikanRoute =
  DesaSlugDashboardPendidikanRouteImport.update({
    id: '/pendidikan',
    path: '/pendidikan',
    getParentRoute: () => DesaSlugDashboardRouteRoute,
  } as any)
const DesaSlugDashboardPemilihanRoute =
  DesaSlugDashboardPemilihanRouteImport.update({
    id: '/pemilihan',
    path: '/pemilihan',
    getParentRoute: () => DesaSlugDashboardRouteRoute,
  } as any)
const DesaSlugDashboardPembangunanRoute =
  DesaSlugDashboardPembangunanRouteImport.update({
    id: '/pembangunan',
    path: '/pembangunan',
    getParentRoute: () => DesaSlugDashboardRouteRoute,
  } as any)
const DesaSlugDashboardPanduanRoute =
  DesaSlugDashboardPanduanRouteImport.update({
    id: '/panduan',
    path: '/panduan',
    getParentRoute: () => DesaSlugDashboardRouteRoute,
  } as any)
const DesaSlugDashboardMusrenbangRoute =
  DesaSlugDashboardMusrenbangRouteImport.update({
    id: '/musrenbang',
    path: '/musrenbang',
    getParentRoute: () => DesaSlugDashboardRouteRoute,
  } as any)
const DesaSlugDashboardMemoryRoute = DesaSlugDashboardMemoryRouteImport.update({
  id: '/memory',
  path: '/memory',
  getParentRoute: () => DesaSlugDashboardRouteRoute,
} as any)
const DesaSlugDashboardLogAktivitasRoute =
  DesaSlugDashboardLogAktivitasRouteImport.update({
    id: '/log-aktivitas',
    path: '/log-aktivitas',
    getParentRoute: () => DesaSlugDashboardRouteRoute,
  } as any)
const DesaSlugDashboardLifeEventsRoute =
  DesaSlugDashboardLifeEventsRouteImport.update({
    id: '/life-events',
    path: '/life-events',
    getParentRoute: () => DesaSlugDashboardRouteRoute,
  } as any)
const DesaSlugDashboardLaporanRoute =
  DesaSlugDashboardLaporanRouteImport.update({
    id: '/laporan',
    path: '/laporan',
    getParentRoute: () => DesaSlugDashboardRouteRoute,
  } as any)
const DesaSlugDashboardKeuanganRoute =
  DesaSlugDashboardKeuanganRouteImport.update({
    id: '/keuangan',
    path: '/keuangan',
    getParentRoute: () => DesaSlugDashboardRouteRoute,
  } as any)
const DesaSlugDashboardKetertibanRoute =
  DesaSlugDashboardKetertibanRouteImport.update({
    id: '/ketertiban',
    path: '/ketertiban',
    getParentRoute: () => DesaSlugDashboardRouteRoute,
  } as any)
const DesaSlugDashboardKesehatanRoute =
  DesaSlugDashboardKesehatanRouteImport.update({
    id: '/kesehatan',
    path: '/kesehatan',
    getParentRoute: () => DesaSlugDashboardRouteRoute,
  } as any)
const DesaSlugDashboardKepribadianAiRoute =
  DesaSlugDashboardKepribadianAiRouteImport.update({
    id: '/kepribadian-ai',
    path: '/kepribadian-ai',
    getParentRoute: () => DesaSlugDashboardRouteRoute,
  } as any)
const DesaSlugDashboardKependudukanRoute =
  DesaSlugDashboardKependudukanRouteImport.update({
    id: '/kependudukan',
    path: '/kependudukan',
    getParentRoute: () => DesaSlugDashboardRouteRoute,
  } as any)
const DesaSlugDashboardKepegawaianRoute =
  DesaSlugDashboardKepegawaianRouteImport.update({
    id: '/kepegawaian',
    path: '/kepegawaian',
    getParentRoute: () => DesaSlugDashboardRouteRoute,
  } as any)
const DesaSlugDashboardKelembagaanRoute =
  DesaSlugDashboardKelembagaanRouteImport.update({
    id: '/kelembagaan',
    path: '/kelembagaan',
    getParentRoute: () => DesaSlugDashboardRouteRoute,
  } as any)
const DesaSlugDashboardJabatanRoute =
  DesaSlugDashboardJabatanRouteImport.update({
    id: '/jabatan',
    path: '/jabatan',
    getParentRoute: () => DesaSlugDashboardRouteRoute,
  } as any)
const DesaSlugDashboardInformasiRoute =
  DesaSlugDashboardInformasiRouteImport.update({
    id: '/informasi',
    path: '/informasi',
    getParentRoute: () => DesaSlugDashboardRouteRoute,
  } as any)
const DesaSlugDashboardEkonomiRoute =
  DesaSlugDashboardEkonomiRouteImport.update({
    id: '/ekonomi',
    path: '/ekonomi',
    getParentRoute: () => DesaSlugDashboardRouteRoute,
  } as any)
const DesaSlugDashboardDraftSuratRoute =
  DesaSlugDashboardDraftSuratRouteImport.update({
    id: '/draft-surat',
    path: '/draft-surat',
    getParentRoute: () => DesaSlugDashboardRouteRoute,
  } as any)
const DesaSlugDashboardDokumenRoute =
  DesaSlugDashboardDokumenRouteImport.update({
    id: '/dokumen',
    path: '/dokumen',
    getParentRoute: () => DesaSlugDashboardRouteRoute,
  } as any)
const DesaSlugDashboardCustomToolsRoute =
  DesaSlugDashboardCustomToolsRouteImport.update({
    id: '/custom-tools',
    path: '/custom-tools',
    getParentRoute: () => DesaSlugDashboardRouteRoute,
  } as any)
const DesaSlugDashboardChannelRoute =
  DesaSlugDashboardChannelRouteImport.update({
    id: '/channel',
    path: '/channel',
    getParentRoute: () => DesaSlugDashboardRouteRoute,
  } as any)
const DesaSlugDashboardBookingRoute =
  DesaSlugDashboardBookingRouteImport.update({
    id: '/booking',
    path: '/booking',
    getParentRoute: () => DesaSlugDashboardRouteRoute,
  } as any)
const DesaSlugDashboardBencanaRoute =
  DesaSlugDashboardBencanaRouteImport.update({
    id: '/bencana',
    path: '/bencana',
    getParentRoute: () => DesaSlugDashboardRouteRoute,
  } as any)
const DesaSlugDashboardBansosRoute = DesaSlugDashboardBansosRouteImport.update({
  id: '/bansos',
  path: '/bansos',
  getParentRoute: () => DesaSlugDashboardRouteRoute,
} as any)
const DesaSlugDashboardAgenRoute = DesaSlugDashboardAgenRouteImport.update({
  id: '/agen',
  path: '/agen',
  getParentRoute: () => DesaSlugDashboardRouteRoute,
} as any)
const DesaSlugDashboardAdministrasiRoute =
  DesaSlugDashboardAdministrasiRouteImport.update({
    id: '/administrasi',
    path: '/administrasi',
    getParentRoute: () => DesaSlugDashboardRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/dashboard': typeof DashboardRouteRouteWithChildren
  '/dev': typeof DevRouteRouteWithChildren
  '/platform': typeof PlatformRouteRouteWithChildren
  '/staff': typeof StaffRouteRoute
  '/complete-profile': typeof CompleteProfileRoute
  '/login': typeof LoginRoute
  '/narasi': typeof NarasiRoute
  '/parkir': typeof ParkirRoute
  '/pilih-desa': typeof PilihDesaRoute
  '/privasi': typeof PrivasiRoute
  '/task-inventory': typeof TaskInventoryRoute
  '/dashboard/desa': typeof DashboardDesaRouteRouteWithChildren
  '/platform/desa': typeof PlatformDesaRouteRouteWithChildren
  '/warga/$slug': typeof WargaSlugRouteRoute
  '/dev/agent-swarm': typeof DevAgentSwarmRoute
  '/dev/ai-flow': typeof DevAiFlowRoute
  '/dev/ai-routing': typeof DevAiRoutingRoute
  '/dev/api-keys': typeof DevApiKeysRoute
  '/dev/code-graph': typeof DevCodeGraphRoute
  '/dev/db-schema': typeof DevDbSchemaRoute
  '/dev/docs': typeof DevDocsRoute
  '/dev/file-health': typeof DevFileHealthRoute
  '/dev/handler-evolution': typeof DevHandlerEvolutionRoute
  '/dev/observability': typeof DevObservabilityRoute
  '/dev/wa-repair-budget': typeof DevWaRepairBudgetRoute
  '/platform/integrasi-desa': typeof PlatformIntegrasiDesaRoute
  '/platform/log-aktivitas': typeof PlatformLogAktivitasRoute
  '/platform/panduan': typeof PlatformPanduanRoute
  '/platform/pengaturan': typeof PlatformPengaturanRoute
  '/platform/pengguna': typeof PlatformPenggunaRoute
  '/platform/tiket': typeof PlatformTiketRoute
  '/platform/whatsapp-server': typeof PlatformWhatsappServerRoute
  '/platform/workers': typeof PlatformWorkersRoute
  '/verify/$kode': typeof VerifyKodeRoute
  '/warga/pilih-desa': typeof WargaPilihDesaRoute
  '/dashboard/': typeof DashboardIndexRoute
  '/dev/': typeof DevIndexRoute
  '/platform/': typeof PlatformIndexRoute
  '/desa/$slug/dashboard': typeof DesaSlugDashboardRouteRouteWithChildren
  '/desa/$slug/laporan': typeof DesaSlugLaporanRouteRouteWithChildren
  '/desa/$slug/warga': typeof DesaSlugWargaRouteRouteWithChildren
  '/platform/desa/$desaId': typeof PlatformDesaDesaIdRouteRouteWithChildren
  '/desa/$slug/booking': typeof DesaSlugBookingRoute
  '/desa/$slug/overview': typeof DesaSlugOverviewRoute
  '/desa/$slug/transparansi': typeof DesaSlugTransparansiRoute
  '/desa/$slug/verifikasi-ktp': typeof DesaSlugVerifikasiKtpRoute
  '/dashboard/desa/': typeof DashboardDesaIndexRoute
  '/desa/$slug/': typeof DesaSlugIndexRoute
  '/platform/desa/': typeof PlatformDesaIndexRoute
  '/desa/$slug/dashboard/administrasi': typeof DesaSlugDashboardAdministrasiRoute
  '/desa/$slug/dashboard/agen': typeof DesaSlugDashboardAgenRoute
  '/desa/$slug/dashboard/bansos': typeof DesaSlugDashboardBansosRoute
  '/desa/$slug/dashboard/bencana': typeof DesaSlugDashboardBencanaRoute
  '/desa/$slug/dashboard/booking': typeof DesaSlugDashboardBookingRoute
  '/desa/$slug/dashboard/channel': typeof DesaSlugDashboardChannelRoute
  '/desa/$slug/dashboard/custom-tools': typeof DesaSlugDashboardCustomToolsRoute
  '/desa/$slug/dashboard/dokumen': typeof DesaSlugDashboardDokumenRoute
  '/desa/$slug/dashboard/draft-surat': typeof DesaSlugDashboardDraftSuratRoute
  '/desa/$slug/dashboard/ekonomi': typeof DesaSlugDashboardEkonomiRoute
  '/desa/$slug/dashboard/informasi': typeof DesaSlugDashboardInformasiRoute
  '/desa/$slug/dashboard/jabatan': typeof DesaSlugDashboardJabatanRoute
  '/desa/$slug/dashboard/kelembagaan': typeof DesaSlugDashboardKelembagaanRoute
  '/desa/$slug/dashboard/kepegawaian': typeof DesaSlugDashboardKepegawaianRoute
  '/desa/$slug/dashboard/kependudukan': typeof DesaSlugDashboardKependudukanRoute
  '/desa/$slug/dashboard/kepribadian-ai': typeof DesaSlugDashboardKepribadianAiRoute
  '/desa/$slug/dashboard/kesehatan': typeof DesaSlugDashboardKesehatanRoute
  '/desa/$slug/dashboard/ketertiban': typeof DesaSlugDashboardKetertibanRoute
  '/desa/$slug/dashboard/keuangan': typeof DesaSlugDashboardKeuanganRoute
  '/desa/$slug/dashboard/laporan': typeof DesaSlugDashboardLaporanRoute
  '/desa/$slug/dashboard/life-events': typeof DesaSlugDashboardLifeEventsRoute
  '/desa/$slug/dashboard/log-aktivitas': typeof DesaSlugDashboardLogAktivitasRoute
  '/desa/$slug/dashboard/memory': typeof DesaSlugDashboardMemoryRoute
  '/desa/$slug/dashboard/musrenbang': typeof DesaSlugDashboardMusrenbangRoute
  '/desa/$slug/dashboard/panduan': typeof DesaSlugDashboardPanduanRoute
  '/desa/$slug/dashboard/pembangunan': typeof DesaSlugDashboardPembangunanRoute
  '/desa/$slug/dashboard/pemilihan': typeof DesaSlugDashboardPemilihanRoute
  '/desa/$slug/dashboard/pendidikan': typeof DesaSlugDashboardPendidikanRoute
  '/desa/$slug/dashboard/pengantar-wilayah': typeof DesaSlugDashboardPengantarWilayahRoute
  '/desa/$slug/dashboard/pengaturan': typeof DesaSlugDashboardPengaturanRoute
  '/desa/$slug/dashboard/percakapan': typeof DesaSlugDashboardPercakapanRoute
  '/desa/$slug/dashboard/pertanahan': typeof DesaSlugDashboardPertanahanRoute
  '/desa/$slug/dashboard/profil-desa': typeof DesaSlugDashboardProfilDesaRoute
  '/desa/$slug/dashboard/riwayat': typeof DesaSlugDashboardRiwayatRoute
  '/desa/$slug/dashboard/staff': typeof DesaSlugDashboardStaffRoute
  '/desa/$slug/dashboard/statistik': typeof DesaSlugDashboardStatistikRoute
  '/desa/$slug/dashboard/surat': typeof DesaSlugDashboardSuratRoute
  '/desa/$slug/dashboard/template-surat': typeof DesaSlugDashboardTemplateSuratRoute
  '/desa/$slug/dashboard/test-ai': typeof DesaSlugDashboardTestAiRoute
  '/desa/$slug/dashboard/tools': typeof DesaSlugDashboardToolsRoute
  '/desa/$slug/form/$kode': typeof DesaSlugFormKodeRoute
  '/desa/$slug/laporan/$id': typeof DesaSlugLaporanIdRoute
  '/desa/$slug/warga/booking': typeof DesaSlugWargaBookingRoute
  '/desa/$slug/warga/chat': typeof DesaSlugWargaChatRoute
  '/desa/$slug/warga/laporan': typeof DesaSlugWargaLaporanRoute
  '/desa/$slug/warga/life-events': typeof DesaSlugWargaLifeEventsRoute
  '/desa/$slug/warga/login': typeof DesaSlugWargaLoginRoute
  '/desa/$slug/warga/profil': typeof DesaSlugWargaProfilRoute
  '/desa/$slug/warga/surat': typeof DesaSlugWargaSuratRoute
  '/platform/desa/$desaId/administrasi': typeof PlatformDesaDesaIdAdministrasiRoute
  '/platform/desa/$desaId/agen': typeof PlatformDesaDesaIdAgenRoute
  '/platform/desa/$desaId/bansos': typeof PlatformDesaDesaIdBansosRoute
  '/platform/desa/$desaId/bencana': typeof PlatformDesaDesaIdBencanaRoute
  '/platform/desa/$desaId/booking': typeof PlatformDesaDesaIdBookingRoute
  '/platform/desa/$desaId/channel': typeof PlatformDesaDesaIdChannelRoute
  '/platform/desa/$desaId/custom-tools': typeof PlatformDesaDesaIdCustomToolsRoute
  '/platform/desa/$desaId/dokumen': typeof PlatformDesaDesaIdDokumenRoute
  '/platform/desa/$desaId/draft-surat': typeof PlatformDesaDesaIdDraftSuratRoute
  '/platform/desa/$desaId/ekonomi': typeof PlatformDesaDesaIdEkonomiRoute
  '/platform/desa/$desaId/informasi': typeof PlatformDesaDesaIdInformasiRoute
  '/platform/desa/$desaId/jabatan': typeof PlatformDesaDesaIdJabatanRoute
  '/platform/desa/$desaId/kelembagaan': typeof PlatformDesaDesaIdKelembagaanRoute
  '/platform/desa/$desaId/kepegawaian': typeof PlatformDesaDesaIdKepegawaianRoute
  '/platform/desa/$desaId/kependudukan': typeof PlatformDesaDesaIdKependudukanRoute
  '/platform/desa/$desaId/kepribadian-ai': typeof PlatformDesaDesaIdKepribadianAiRoute
  '/platform/desa/$desaId/kesehatan': typeof PlatformDesaDesaIdKesehatanRoute
  '/platform/desa/$desaId/ketertiban': typeof PlatformDesaDesaIdKetertibanRoute
  '/platform/desa/$desaId/keuangan': typeof PlatformDesaDesaIdKeuanganRoute
  '/platform/desa/$desaId/laporan': typeof PlatformDesaDesaIdLaporanRoute
  '/platform/desa/$desaId/life-events': typeof PlatformDesaDesaIdLifeEventsRoute
  '/platform/desa/$desaId/log-aktivitas': typeof PlatformDesaDesaIdLogAktivitasRoute
  '/platform/desa/$desaId/memory': typeof PlatformDesaDesaIdMemoryRoute
  '/platform/desa/$desaId/musrenbang': typeof PlatformDesaDesaIdMusrenbangRoute
  '/platform/desa/$desaId/panduan': typeof PlatformDesaDesaIdPanduanRoute
  '/platform/desa/$desaId/pembangunan': typeof PlatformDesaDesaIdPembangunanRoute
  '/platform/desa/$desaId/pemilihan': typeof PlatformDesaDesaIdPemilihanRoute
  '/platform/desa/$desaId/pendidikan': typeof PlatformDesaDesaIdPendidikanRoute
  '/platform/desa/$desaId/pengantar-wilayah': typeof PlatformDesaDesaIdPengantarWilayahRoute
  '/platform/desa/$desaId/pengaturan': typeof PlatformDesaDesaIdPengaturanRoute
  '/platform/desa/$desaId/percakapan': typeof PlatformDesaDesaIdPercakapanRoute
  '/platform/desa/$desaId/pertanahan': typeof PlatformDesaDesaIdPertanahanRoute
  '/platform/desa/$desaId/profil-desa': typeof PlatformDesaDesaIdProfilDesaRoute
  '/platform/desa/$desaId/riwayat': typeof PlatformDesaDesaIdRiwayatRoute
  '/platform/desa/$desaId/staff': typeof PlatformDesaDesaIdStaffRoute
  '/platform/desa/$desaId/statistik': typeof PlatformDesaDesaIdStatistikRoute
  '/platform/desa/$desaId/surat': typeof PlatformDesaDesaIdSuratRoute
  '/platform/desa/$desaId/template-surat': typeof PlatformDesaDesaIdTemplateSuratRoute
  '/platform/desa/$desaId/test-ai': typeof PlatformDesaDesaIdTestAiRoute
  '/platform/desa/$desaId/tools': typeof PlatformDesaDesaIdToolsRoute
  '/desa/$slug/dashboard/': typeof DesaSlugDashboardIndexRoute
  '/desa/$slug/laporan/': typeof DesaSlugLaporanIndexRoute
  '/desa/$slug/warga/': typeof DesaSlugWargaIndexRoute
  '/platform/desa/$desaId/': typeof PlatformDesaDesaIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/staff': typeof StaffRouteRoute
  '/complete-profile': typeof CompleteProfileRoute
  '/login': typeof LoginRoute
  '/narasi': typeof NarasiRoute
  '/parkir': typeof ParkirRoute
  '/pilih-desa': typeof PilihDesaRoute
  '/privasi': typeof PrivasiRoute
  '/task-inventory': typeof TaskInventoryRoute
  '/warga/$slug': typeof WargaSlugRouteRoute
  '/dev/agent-swarm': typeof DevAgentSwarmRoute
  '/dev/ai-flow': typeof DevAiFlowRoute
  '/dev/ai-routing': typeof DevAiRoutingRoute
  '/dev/api-keys': typeof DevApiKeysRoute
  '/dev/code-graph': typeof DevCodeGraphRoute
  '/dev/db-schema': typeof DevDbSchemaRoute
  '/dev/docs': typeof DevDocsRoute
  '/dev/file-health': typeof DevFileHealthRoute
  '/dev/handler-evolution': typeof DevHandlerEvolutionRoute
  '/dev/observability': typeof DevObservabilityRoute
  '/dev/wa-repair-budget': typeof DevWaRepairBudgetRoute
  '/platform/integrasi-desa': typeof PlatformIntegrasiDesaRoute
  '/platform/log-aktivitas': typeof PlatformLogAktivitasRoute
  '/platform/panduan': typeof PlatformPanduanRoute
  '/platform/pengaturan': typeof PlatformPengaturanRoute
  '/platform/pengguna': typeof PlatformPenggunaRoute
  '/platform/tiket': typeof PlatformTiketRoute
  '/platform/whatsapp-server': typeof PlatformWhatsappServerRoute
  '/platform/workers': typeof PlatformWorkersRoute
  '/verify/$kode': typeof VerifyKodeRoute
  '/warga/pilih-desa': typeof WargaPilihDesaRoute
  '/dashboard': typeof DashboardIndexRoute
  '/dev': typeof DevIndexRoute
  '/platform': typeof PlatformIndexRoute
  '/desa/$slug/booking': typeof DesaSlugBookingRoute
  '/desa/$slug/overview': typeof DesaSlugOverviewRoute
  '/desa/$slug/transparansi': typeof DesaSlugTransparansiRoute
  '/desa/$slug/verifikasi-ktp': typeof DesaSlugVerifikasiKtpRoute
  '/dashboard/desa': typeof DashboardDesaIndexRoute
  '/desa/$slug': typeof DesaSlugIndexRoute
  '/platform/desa': typeof PlatformDesaIndexRoute
  '/desa/$slug/dashboard/administrasi': typeof DesaSlugDashboardAdministrasiRoute
  '/desa/$slug/dashboard/agen': typeof DesaSlugDashboardAgenRoute
  '/desa/$slug/dashboard/bansos': typeof DesaSlugDashboardBansosRoute
  '/desa/$slug/dashboard/bencana': typeof DesaSlugDashboardBencanaRoute
  '/desa/$slug/dashboard/booking': typeof DesaSlugDashboardBookingRoute
  '/desa/$slug/dashboard/channel': typeof DesaSlugDashboardChannelRoute
  '/desa/$slug/dashboard/custom-tools': typeof DesaSlugDashboardCustomToolsRoute
  '/desa/$slug/dashboard/dokumen': typeof DesaSlugDashboardDokumenRoute
  '/desa/$slug/dashboard/draft-surat': typeof DesaSlugDashboardDraftSuratRoute
  '/desa/$slug/dashboard/ekonomi': typeof DesaSlugDashboardEkonomiRoute
  '/desa/$slug/dashboard/informasi': typeof DesaSlugDashboardInformasiRoute
  '/desa/$slug/dashboard/jabatan': typeof DesaSlugDashboardJabatanRoute
  '/desa/$slug/dashboard/kelembagaan': typeof DesaSlugDashboardKelembagaanRoute
  '/desa/$slug/dashboard/kepegawaian': typeof DesaSlugDashboardKepegawaianRoute
  '/desa/$slug/dashboard/kependudukan': typeof DesaSlugDashboardKependudukanRoute
  '/desa/$slug/dashboard/kepribadian-ai': typeof DesaSlugDashboardKepribadianAiRoute
  '/desa/$slug/dashboard/kesehatan': typeof DesaSlugDashboardKesehatanRoute
  '/desa/$slug/dashboard/ketertiban': typeof DesaSlugDashboardKetertibanRoute
  '/desa/$slug/dashboard/keuangan': typeof DesaSlugDashboardKeuanganRoute
  '/desa/$slug/dashboard/laporan': typeof DesaSlugDashboardLaporanRoute
  '/desa/$slug/dashboard/life-events': typeof DesaSlugDashboardLifeEventsRoute
  '/desa/$slug/dashboard/log-aktivitas': typeof DesaSlugDashboardLogAktivitasRoute
  '/desa/$slug/dashboard/memory': typeof DesaSlugDashboardMemoryRoute
  '/desa/$slug/dashboard/musrenbang': typeof DesaSlugDashboardMusrenbangRoute
  '/desa/$slug/dashboard/panduan': typeof DesaSlugDashboardPanduanRoute
  '/desa/$slug/dashboard/pembangunan': typeof DesaSlugDashboardPembangunanRoute
  '/desa/$slug/dashboard/pemilihan': typeof DesaSlugDashboardPemilihanRoute
  '/desa/$slug/dashboard/pendidikan': typeof DesaSlugDashboardPendidikanRoute
  '/desa/$slug/dashboard/pengantar-wilayah': typeof DesaSlugDashboardPengantarWilayahRoute
  '/desa/$slug/dashboard/pengaturan': typeof DesaSlugDashboardPengaturanRoute
  '/desa/$slug/dashboard/percakapan': typeof DesaSlugDashboardPercakapanRoute
  '/desa/$slug/dashboard/pertanahan': typeof DesaSlugDashboardPertanahanRoute
  '/desa/$slug/dashboard/profil-desa': typeof DesaSlugDashboardProfilDesaRoute
  '/desa/$slug/dashboard/riwayat': typeof DesaSlugDashboardRiwayatRoute
  '/desa/$slug/dashboard/staff': typeof DesaSlugDashboardStaffRoute
  '/desa/$slug/dashboard/statistik': typeof DesaSlugDashboardStatistikRoute
  '/desa/$slug/dashboard/surat': typeof DesaSlugDashboardSuratRoute
  '/desa/$slug/dashboard/template-surat': typeof DesaSlugDashboardTemplateSuratRoute
  '/desa/$slug/dashboard/test-ai': typeof DesaSlugDashboardTestAiRoute
  '/desa/$slug/dashboard/tools': typeof DesaSlugDashboardToolsRoute
  '/desa/$slug/form/$kode': typeof DesaSlugFormKodeRoute
  '/desa/$slug/laporan/$id': typeof DesaSlugLaporanIdRoute
  '/desa/$slug/warga/booking': typeof DesaSlugWargaBookingRoute
  '/desa/$slug/warga/chat': typeof DesaSlugWargaChatRoute
  '/desa/$slug/warga/laporan': typeof DesaSlugWargaLaporanRoute
  '/desa/$slug/warga/life-events': typeof DesaSlugWargaLifeEventsRoute
  '/desa/$slug/warga/login': typeof DesaSlugWargaLoginRoute
  '/desa/$slug/warga/profil': typeof DesaSlugWargaProfilRoute
  '/desa/$slug/warga/surat': typeof DesaSlugWargaSuratRoute
  '/platform/desa/$desaId/administrasi': typeof PlatformDesaDesaIdAdministrasiRoute
  '/platform/desa/$desaId/agen': typeof PlatformDesaDesaIdAgenRoute
  '/platform/desa/$desaId/bansos': typeof PlatformDesaDesaIdBansosRoute
  '/platform/desa/$desaId/bencana': typeof PlatformDesaDesaIdBencanaRoute
  '/platform/desa/$desaId/booking': typeof PlatformDesaDesaIdBookingRoute
  '/platform/desa/$desaId/channel': typeof PlatformDesaDesaIdChannelRoute
  '/platform/desa/$desaId/custom-tools': typeof PlatformDesaDesaIdCustomToolsRoute
  '/platform/desa/$desaId/dokumen': typeof PlatformDesaDesaIdDokumenRoute
  '/platform/desa/$desaId/draft-surat': typeof PlatformDesaDesaIdDraftSuratRoute
  '/platform/desa/$desaId/ekonomi': typeof PlatformDesaDesaIdEkonomiRoute
  '/platform/desa/$desaId/informasi': typeof PlatformDesaDesaIdInformasiRoute
  '/platform/desa/$desaId/jabatan': typeof PlatformDesaDesaIdJabatanRoute
  '/platform/desa/$desaId/kelembagaan': typeof PlatformDesaDesaIdKelembagaanRoute
  '/platform/desa/$desaId/kepegawaian': typeof PlatformDesaDesaIdKepegawaianRoute
  '/platform/desa/$desaId/kependudukan': typeof PlatformDesaDesaIdKependudukanRoute
  '/platform/desa/$desaId/kepribadian-ai': typeof PlatformDesaDesaIdKepribadianAiRoute
  '/platform/desa/$desaId/kesehatan': typeof PlatformDesaDesaIdKesehatanRoute
  '/platform/desa/$desaId/ketertiban': typeof PlatformDesaDesaIdKetertibanRoute
  '/platform/desa/$desaId/keuangan': typeof PlatformDesaDesaIdKeuanganRoute
  '/platform/desa/$desaId/laporan': typeof PlatformDesaDesaIdLaporanRoute
  '/platform/desa/$desaId/life-events': typeof PlatformDesaDesaIdLifeEventsRoute
  '/platform/desa/$desaId/log-aktivitas': typeof PlatformDesaDesaIdLogAktivitasRoute
  '/platform/desa/$desaId/memory': typeof PlatformDesaDesaIdMemoryRoute
  '/platform/desa/$desaId/musrenbang': typeof PlatformDesaDesaIdMusrenbangRoute
  '/platform/desa/$desaId/panduan': typeof PlatformDesaDesaIdPanduanRoute
  '/platform/desa/$desaId/pembangunan': typeof PlatformDesaDesaIdPembangunanRoute
  '/platform/desa/$desaId/pemilihan': typeof PlatformDesaDesaIdPemilihanRoute
  '/platform/desa/$desaId/pendidikan': typeof PlatformDesaDesaIdPendidikanRoute
  '/platform/desa/$desaId/pengantar-wilayah': typeof PlatformDesaDesaIdPengantarWilayahRoute
  '/platform/desa/$desaId/pengaturan': typeof PlatformDesaDesaIdPengaturanRoute
  '/platform/desa/$desaId/percakapan': typeof PlatformDesaDesaIdPercakapanRoute
  '/platform/desa/$desaId/pertanahan': typeof PlatformDesaDesaIdPertanahanRoute
  '/platform/desa/$desaId/profil-desa': typeof PlatformDesaDesaIdProfilDesaRoute
  '/platform/desa/$desaId/riwayat': typeof PlatformDesaDesaIdRiwayatRoute
  '/platform/desa/$desaId/staff': typeof PlatformDesaDesaIdStaffRoute
  '/platform/desa/$desaId/statistik': typeof PlatformDesaDesaIdStatistikRoute
  '/platform/desa/$desaId/surat': typeof PlatformDesaDesaIdSuratRoute
  '/platform/desa/$desaId/template-surat': typeof PlatformDesaDesaIdTemplateSuratRoute
  '/platform/desa/$desaId/test-ai': typeof PlatformDesaDesaIdTestAiRoute
  '/platform/desa/$desaId/tools': typeof PlatformDesaDesaIdToolsRoute
  '/desa/$slug/dashboard': typeof DesaSlugDashboardIndexRoute
  '/desa/$slug/laporan': typeof DesaSlugLaporanIndexRoute
  '/desa/$slug/warga': typeof DesaSlugWargaIndexRoute
  '/platform/desa/$desaId': typeof PlatformDesaDesaIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/dashboard': typeof DashboardRouteRouteWithChildren
  '/dev': typeof DevRouteRouteWithChildren
  '/platform': typeof PlatformRouteRouteWithChildren
  '/staff': typeof StaffRouteRoute
  '/complete-profile': typeof CompleteProfileRoute
  '/login': typeof LoginRoute
  '/narasi': typeof NarasiRoute
  '/parkir': typeof ParkirRoute
  '/pilih-desa': typeof PilihDesaRoute
  '/privasi': typeof PrivasiRoute
  '/task-inventory': typeof TaskInventoryRoute
  '/dashboard/desa': typeof DashboardDesaRouteRouteWithChildren
  '/platform/desa': typeof PlatformDesaRouteRouteWithChildren
  '/warga/$slug': typeof WargaSlugRouteRoute
  '/dev/agent-swarm': typeof DevAgentSwarmRoute
  '/dev/ai-flow': typeof DevAiFlowRoute
  '/dev/ai-routing': typeof DevAiRoutingRoute
  '/dev/api-keys': typeof DevApiKeysRoute
  '/dev/code-graph': typeof DevCodeGraphRoute
  '/dev/db-schema': typeof DevDbSchemaRoute
  '/dev/docs': typeof DevDocsRoute
  '/dev/file-health': typeof DevFileHealthRoute
  '/dev/handler-evolution': typeof DevHandlerEvolutionRoute
  '/dev/observability': typeof DevObservabilityRoute
  '/dev/wa-repair-budget': typeof DevWaRepairBudgetRoute
  '/platform/integrasi-desa': typeof PlatformIntegrasiDesaRoute
  '/platform/log-aktivitas': typeof PlatformLogAktivitasRoute
  '/platform/panduan': typeof PlatformPanduanRoute
  '/platform/pengaturan': typeof PlatformPengaturanRoute
  '/platform/pengguna': typeof PlatformPenggunaRoute
  '/platform/tiket': typeof PlatformTiketRoute
  '/platform/whatsapp-server': typeof PlatformWhatsappServerRoute
  '/platform/workers': typeof PlatformWorkersRoute
  '/verify/$kode': typeof VerifyKodeRoute
  '/warga/pilih-desa': typeof WargaPilihDesaRoute
  '/dashboard/': typeof DashboardIndexRoute
  '/dev/': typeof DevIndexRoute
  '/platform/': typeof PlatformIndexRoute
  '/desa/$slug/dashboard': typeof DesaSlugDashboardRouteRouteWithChildren
  '/desa/$slug/laporan': typeof DesaSlugLaporanRouteRouteWithChildren
  '/desa/$slug/warga': typeof DesaSlugWargaRouteRouteWithChildren
  '/platform/desa/$desaId': typeof PlatformDesaDesaIdRouteRouteWithChildren
  '/desa/$slug/booking': typeof DesaSlugBookingRoute
  '/desa/$slug/overview': typeof DesaSlugOverviewRoute
  '/desa/$slug/transparansi': typeof DesaSlugTransparansiRoute
  '/desa/$slug/verifikasi-ktp': typeof DesaSlugVerifikasiKtpRoute
  '/dashboard/desa/': typeof DashboardDesaIndexRoute
  '/desa/$slug/': typeof DesaSlugIndexRoute
  '/platform/desa/': typeof PlatformDesaIndexRoute
  '/desa/$slug/dashboard/administrasi': typeof DesaSlugDashboardAdministrasiRoute
  '/desa/$slug/dashboard/agen': typeof DesaSlugDashboardAgenRoute
  '/desa/$slug/dashboard/bansos': typeof DesaSlugDashboardBansosRoute
  '/desa/$slug/dashboard/bencana': typeof DesaSlugDashboardBencanaRoute
  '/desa/$slug/dashboard/booking': typeof DesaSlugDashboardBookingRoute
  '/desa/$slug/dashboard/channel': typeof DesaSlugDashboardChannelRoute
  '/desa/$slug/dashboard/custom-tools': typeof DesaSlugDashboardCustomToolsRoute
  '/desa/$slug/dashboard/dokumen': typeof DesaSlugDashboardDokumenRoute
  '/desa/$slug/dashboard/draft-surat': typeof DesaSlugDashboardDraftSuratRoute
  '/desa/$slug/dashboard/ekonomi': typeof DesaSlugDashboardEkonomiRoute
  '/desa/$slug/dashboard/informasi': typeof DesaSlugDashboardInformasiRoute
  '/desa/$slug/dashboard/jabatan': typeof DesaSlugDashboardJabatanRoute
  '/desa/$slug/dashboard/kelembagaan': typeof DesaSlugDashboardKelembagaanRoute
  '/desa/$slug/dashboard/kepegawaian': typeof DesaSlugDashboardKepegawaianRoute
  '/desa/$slug/dashboard/kependudukan': typeof DesaSlugDashboardKependudukanRoute
  '/desa/$slug/dashboard/kepribadian-ai': typeof DesaSlugDashboardKepribadianAiRoute
  '/desa/$slug/dashboard/kesehatan': typeof DesaSlugDashboardKesehatanRoute
  '/desa/$slug/dashboard/ketertiban': typeof DesaSlugDashboardKetertibanRoute
  '/desa/$slug/dashboard/keuangan': typeof DesaSlugDashboardKeuanganRoute
  '/desa/$slug/dashboard/laporan': typeof DesaSlugDashboardLaporanRoute
  '/desa/$slug/dashboard/life-events': typeof DesaSlugDashboardLifeEventsRoute
  '/desa/$slug/dashboard/log-aktivitas': typeof DesaSlugDashboardLogAktivitasRoute
  '/desa/$slug/dashboard/memory': typeof DesaSlugDashboardMemoryRoute
  '/desa/$slug/dashboard/musrenbang': typeof DesaSlugDashboardMusrenbangRoute
  '/desa/$slug/dashboard/panduan': typeof DesaSlugDashboardPanduanRoute
  '/desa/$slug/dashboard/pembangunan': typeof DesaSlugDashboardPembangunanRoute
  '/desa/$slug/dashboard/pemilihan': typeof DesaSlugDashboardPemilihanRoute
  '/desa/$slug/dashboard/pendidikan': typeof DesaSlugDashboardPendidikanRoute
  '/desa/$slug/dashboard/pengantar-wilayah': typeof DesaSlugDashboardPengantarWilayahRoute
  '/desa/$slug/dashboard/pengaturan': typeof DesaSlugDashboardPengaturanRoute
  '/desa/$slug/dashboard/percakapan': typeof DesaSlugDashboardPercakapanRoute
  '/desa/$slug/dashboard/pertanahan': typeof DesaSlugDashboardPertanahanRoute
  '/desa/$slug/dashboard/profil-desa': typeof DesaSlugDashboardProfilDesaRoute
  '/desa/$slug/dashboard/riwayat': typeof DesaSlugDashboardRiwayatRoute
  '/desa/$slug/dashboard/staff': typeof DesaSlugDashboardStaffRoute
  '/desa/$slug/dashboard/statistik': typeof DesaSlugDashboardStatistikRoute
  '/desa/$slug/dashboard/surat': typeof DesaSlugDashboardSuratRoute
  '/desa/$slug/dashboard/template-surat': typeof DesaSlugDashboardTemplateSuratRoute
  '/desa/$slug/dashboard/test-ai': typeof DesaSlugDashboardTestAiRoute
  '/desa/$slug/dashboard/tools': typeof DesaSlugDashboardToolsRoute
  '/desa/$slug/form/$kode': typeof DesaSlugFormKodeRoute
  '/desa/$slug/laporan/$id': typeof DesaSlugLaporanIdRoute
  '/desa/$slug/warga/booking': typeof DesaSlugWargaBookingRoute
  '/desa/$slug/warga/chat': typeof DesaSlugWargaChatRoute
  '/desa/$slug/warga/laporan': typeof DesaSlugWargaLaporanRoute
  '/desa/$slug/warga/life-events': typeof DesaSlugWargaLifeEventsRoute
  '/desa/$slug/warga/login': typeof DesaSlugWargaLoginRoute
  '/desa/$slug/warga/profil': typeof DesaSlugWargaProfilRoute
  '/desa/$slug/warga/surat': typeof DesaSlugWargaSuratRoute
  '/platform/desa/$desaId/administrasi': typeof PlatformDesaDesaIdAdministrasiRoute
  '/platform/desa/$desaId/agen': typeof PlatformDesaDesaIdAgenRoute
  '/platform/desa/$desaId/bansos': typeof PlatformDesaDesaIdBansosRoute
  '/platform/desa/$desaId/bencana': typeof PlatformDesaDesaIdBencanaRoute
  '/platform/desa/$desaId/booking': typeof PlatformDesaDesaIdBookingRoute
  '/platform/desa/$desaId/channel': typeof PlatformDesaDesaIdChannelRoute
  '/platform/desa/$desaId/custom-tools': typeof PlatformDesaDesaIdCustomToolsRoute
  '/platform/desa/$desaId/dokumen': typeof PlatformDesaDesaIdDokumenRoute
  '/platform/desa/$desaId/draft-surat': typeof PlatformDesaDesaIdDraftSuratRoute
  '/platform/desa/$desaId/ekonomi': typeof PlatformDesaDesaIdEkonomiRoute
  '/platform/desa/$desaId/informasi': typeof PlatformDesaDesaIdInformasiRoute
  '/platform/desa/$desaId/jabatan': typeof PlatformDesaDesaIdJabatanRoute
  '/platform/desa/$desaId/kelembagaan': typeof PlatformDesaDesaIdKelembagaanRoute
  '/platform/desa/$desaId/kepegawaian': typeof PlatformDesaDesaIdKepegawaianRoute
  '/platform/desa/$desaId/kependudukan': typeof PlatformDesaDesaIdKependudukanRoute
  '/platform/desa/$desaId/kepribadian-ai': typeof PlatformDesaDesaIdKepribadianAiRoute
  '/platform/desa/$desaId/kesehatan': typeof PlatformDesaDesaIdKesehatanRoute
  '/platform/desa/$desaId/ketertiban': typeof PlatformDesaDesaIdKetertibanRoute
  '/platform/desa/$desaId/keuangan': typeof PlatformDesaDesaIdKeuanganRoute
  '/platform/desa/$desaId/laporan': typeof PlatformDesaDesaIdLaporanRoute
  '/platform/desa/$desaId/life-events': typeof PlatformDesaDesaIdLifeEventsRoute
  '/platform/desa/$desaId/log-aktivitas': typeof PlatformDesaDesaIdLogAktivitasRoute
  '/platform/desa/$desaId/memory': typeof PlatformDesaDesaIdMemoryRoute
  '/platform/desa/$desaId/musrenbang': typeof PlatformDesaDesaIdMusrenbangRoute
  '/platform/desa/$desaId/panduan': typeof PlatformDesaDesaIdPanduanRoute
  '/platform/desa/$desaId/pembangunan': typeof PlatformDesaDesaIdPembangunanRoute
  '/platform/desa/$desaId/pemilihan': typeof PlatformDesaDesaIdPemilihanRoute
  '/platform/desa/$desaId/pendidikan': typeof PlatformDesaDesaIdPendidikanRoute
  '/platform/desa/$desaId/pengantar-wilayah': typeof PlatformDesaDesaIdPengantarWilayahRoute
  '/platform/desa/$desaId/pengaturan': typeof PlatformDesaDesaIdPengaturanRoute
  '/platform/desa/$desaId/percakapan': typeof PlatformDesaDesaIdPercakapanRoute
  '/platform/desa/$desaId/pertanahan': typeof PlatformDesaDesaIdPertanahanRoute
  '/platform/desa/$desaId/profil-desa': typeof PlatformDesaDesaIdProfilDesaRoute
  '/platform/desa/$desaId/riwayat': typeof PlatformDesaDesaIdRiwayatRoute
  '/platform/desa/$desaId/staff': typeof PlatformDesaDesaIdStaffRoute
  '/platform/desa/$desaId/statistik': typeof PlatformDesaDesaIdStatistikRoute
  '/platform/desa/$desaId/surat': typeof PlatformDesaDesaIdSuratRoute
  '/platform/desa/$desaId/template-surat': typeof PlatformDesaDesaIdTemplateSuratRoute
  '/platform/desa/$desaId/test-ai': typeof PlatformDesaDesaIdTestAiRoute
  '/platform/desa/$desaId/tools': typeof PlatformDesaDesaIdToolsRoute
  '/desa/$slug/dashboard/': typeof DesaSlugDashboardIndexRoute
  '/desa/$slug/laporan/': typeof DesaSlugLaporanIndexRoute
  '/desa/$slug/warga/': typeof DesaSlugWargaIndexRoute
  '/platform/desa/$desaId/': typeof PlatformDesaDesaIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/dashboard'
    | '/dev'
    | '/platform'
    | '/staff'
    | '/complete-profile'
    | '/login'
    | '/narasi'
    | '/parkir'
    | '/pilih-desa'
    | '/privasi'
    | '/task-inventory'
    | '/dashboard/desa'
    | '/platform/desa'
    | '/warga/$slug'
    | '/dev/agent-swarm'
    | '/dev/ai-flow'
    | '/dev/ai-routing'
    | '/dev/api-keys'
    | '/dev/code-graph'
    | '/dev/db-schema'
    | '/dev/docs'
    | '/dev/file-health'
    | '/dev/handler-evolution'
    | '/dev/observability'
    | '/dev/wa-repair-budget'
    | '/platform/integrasi-desa'
    | '/platform/log-aktivitas'
    | '/platform/panduan'
    | '/platform/pengaturan'
    | '/platform/pengguna'
    | '/platform/tiket'
    | '/platform/whatsapp-server'
    | '/platform/workers'
    | '/verify/$kode'
    | '/warga/pilih-desa'
    | '/dashboard/'
    | '/dev/'
    | '/platform/'
    | '/desa/$slug/dashboard'
    | '/desa/$slug/laporan'
    | '/desa/$slug/warga'
    | '/platform/desa/$desaId'
    | '/desa/$slug/booking'
    | '/desa/$slug/overview'
    | '/desa/$slug/transparansi'
    | '/desa/$slug/verifikasi-ktp'
    | '/dashboard/desa/'
    | '/desa/$slug/'
    | '/platform/desa/'
    | '/desa/$slug/dashboard/administrasi'
    | '/desa/$slug/dashboard/agen'
    | '/desa/$slug/dashboard/bansos'
    | '/desa/$slug/dashboard/bencana'
    | '/desa/$slug/dashboard/booking'
    | '/desa/$slug/dashboard/channel'
    | '/desa/$slug/dashboard/custom-tools'
    | '/desa/$slug/dashboard/dokumen'
    | '/desa/$slug/dashboard/draft-surat'
    | '/desa/$slug/dashboard/ekonomi'
    | '/desa/$slug/dashboard/informasi'
    | '/desa/$slug/dashboard/jabatan'
    | '/desa/$slug/dashboard/kelembagaan'
    | '/desa/$slug/dashboard/kepegawaian'
    | '/desa/$slug/dashboard/kependudukan'
    | '/desa/$slug/dashboard/kepribadian-ai'
    | '/desa/$slug/dashboard/kesehatan'
    | '/desa/$slug/dashboard/ketertiban'
    | '/desa/$slug/dashboard/keuangan'
    | '/desa/$slug/dashboard/laporan'
    | '/desa/$slug/dashboard/life-events'
    | '/desa/$slug/dashboard/log-aktivitas'
    | '/desa/$slug/dashboard/memory'
    | '/desa/$slug/dashboard/musrenbang'
    | '/desa/$slug/dashboard/panduan'
    | '/desa/$slug/dashboard/pembangunan'
    | '/desa/$slug/dashboard/pemilihan'
    | '/desa/$slug/dashboard/pendidikan'
    | '/desa/$slug/dashboard/pengantar-wilayah'
    | '/desa/$slug/dashboard/pengaturan'
    | '/desa/$slug/dashboard/percakapan'
    | '/desa/$slug/dashboard/pertanahan'
    | '/desa/$slug/dashboard/profil-desa'
    | '/desa/$slug/dashboard/riwayat'
    | '/desa/$slug/dashboard/staff'
    | '/desa/$slug/dashboard/statistik'
    | '/desa/$slug/dashboard/surat'
    | '/desa/$slug/dashboard/template-surat'
    | '/desa/$slug/dashboard/test-ai'
    | '/desa/$slug/dashboard/tools'
    | '/desa/$slug/form/$kode'
    | '/desa/$slug/laporan/$id'
    | '/desa/$slug/warga/booking'
    | '/desa/$slug/warga/chat'
    | '/desa/$slug/warga/laporan'
    | '/desa/$slug/warga/life-events'
    | '/desa/$slug/warga/login'
    | '/desa/$slug/warga/profil'
    | '/desa/$slug/warga/surat'
    | '/platform/desa/$desaId/administrasi'
    | '/platform/desa/$desaId/agen'
    | '/platform/desa/$desaId/bansos'
    | '/platform/desa/$desaId/bencana'
    | '/platform/desa/$desaId/booking'
    | '/platform/desa/$desaId/channel'
    | '/platform/desa/$desaId/custom-tools'
    | '/platform/desa/$desaId/dokumen'
    | '/platform/desa/$desaId/draft-surat'
    | '/platform/desa/$desaId/ekonomi'
    | '/platform/desa/$desaId/informasi'
    | '/platform/desa/$desaId/jabatan'
    | '/platform/desa/$desaId/kelembagaan'
    | '/platform/desa/$desaId/kepegawaian'
    | '/platform/desa/$desaId/kependudukan'
    | '/platform/desa/$desaId/kepribadian-ai'
    | '/platform/desa/$desaId/kesehatan'
    | '/platform/desa/$desaId/ketertiban'
    | '/platform/desa/$desaId/keuangan'
    | '/platform/desa/$desaId/laporan'
    | '/platform/desa/$desaId/life-events'
    | '/platform/desa/$desaId/log-aktivitas'
    | '/platform/desa/$desaId/memory'
    | '/platform/desa/$desaId/musrenbang'
    | '/platform/desa/$desaId/panduan'
    | '/platform/desa/$desaId/pembangunan'
    | '/platform/desa/$desaId/pemilihan'
    | '/platform/desa/$desaId/pendidikan'
    | '/platform/desa/$desaId/pengantar-wilayah'
    | '/platform/desa/$desaId/pengaturan'
    | '/platform/desa/$desaId/percakapan'
    | '/platform/desa/$desaId/pertanahan'
    | '/platform/desa/$desaId/profil-desa'
    | '/platform/desa/$desaId/riwayat'
    | '/platform/desa/$desaId/staff'
    | '/platform/desa/$desaId/statistik'
    | '/platform/desa/$desaId/surat'
    | '/platform/desa/$desaId/template-surat'
    | '/platform/desa/$desaId/test-ai'
    | '/platform/desa/$desaId/tools'
    | '/desa/$slug/dashboard/'
    | '/desa/$slug/laporan/'
    | '/desa/$slug/warga/'
    | '/platform/desa/$desaId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/staff'
    | '/complete-profile'
    | '/login'
    | '/narasi'
    | '/parkir'
    | '/pilih-desa'
    | '/privasi'
    | '/task-inventory'
    | '/warga/$slug'
    | '/dev/agent-swarm'
    | '/dev/ai-flow'
    | '/dev/ai-routing'
    | '/dev/api-keys'
    | '/dev/code-graph'
    | '/dev/db-schema'
    | '/dev/docs'
    | '/dev/file-health'
    | '/dev/handler-evolution'
    | '/dev/observability'
    | '/dev/wa-repair-budget'
    | '/platform/integrasi-desa'
    | '/platform/log-aktivitas'
    | '/platform/panduan'
    | '/platform/pengaturan'
    | '/platform/pengguna'
    | '/platform/tiket'
    | '/platform/whatsapp-server'
    | '/platform/workers'
    | '/verify/$kode'
    | '/warga/pilih-desa'
    | '/dashboard'
    | '/dev'
    | '/platform'
    | '/desa/$slug/booking'
    | '/desa/$slug/overview'
    | '/desa/$slug/transparansi'
    | '/desa/$slug/verifikasi-ktp'
    | '/dashboard/desa'
    | '/desa/$slug'
    | '/platform/desa'
    | '/desa/$slug/dashboard/administrasi'
    | '/desa/$slug/dashboard/agen'
    | '/desa/$slug/dashboard/bansos'
    | '/desa/$slug/dashboard/bencana'
    | '/desa/$slug/dashboard/booking'
    | '/desa/$slug/dashboard/channel'
    | '/desa/$slug/dashboard/custom-tools'
    | '/desa/$slug/dashboard/dokumen'
    | '/desa/$slug/dashboard/draft-surat'
    | '/desa/$slug/dashboard/ekonomi'
    | '/desa/$slug/dashboard/informasi'
    | '/desa/$slug/dashboard/jabatan'
    | '/desa/$slug/dashboard/kelembagaan'
    | '/desa/$slug/dashboard/kepegawaian'
    | '/desa/$slug/dashboard/kependudukan'
    | '/desa/$slug/dashboard/kepribadian-ai'
    | '/desa/$slug/dashboard/kesehatan'
    | '/desa/$slug/dashboard/ketertiban'
    | '/desa/$slug/dashboard/keuangan'
    | '/desa/$slug/dashboard/laporan'
    | '/desa/$slug/dashboard/life-events'
    | '/desa/$slug/dashboard/log-aktivitas'
    | '/desa/$slug/dashboard/memory'
    | '/desa/$slug/dashboard/musrenbang'
    | '/desa/$slug/dashboard/panduan'
    | '/desa/$slug/dashboard/pembangunan'
    | '/desa/$slug/dashboard/pemilihan'
    | '/desa/$slug/dashboard/pendidikan'
    | '/desa/$slug/dashboard/pengantar-wilayah'
    | '/desa/$slug/dashboard/pengaturan'
    | '/desa/$slug/dashboard/percakapan'
    | '/desa/$slug/dashboard/pertanahan'
    | '/desa/$slug/dashboard/profil-desa'
    | '/desa/$slug/dashboard/riwayat'
    | '/desa/$slug/dashboard/staff'
    | '/desa/$slug/dashboard/statistik'
    | '/desa/$slug/dashboard/surat'
    | '/desa/$slug/dashboard/template-surat'
    | '/desa/$slug/dashboard/test-ai'
    | '/desa/$slug/dashboard/tools'
    | '/desa/$slug/form/$kode'
    | '/desa/$slug/laporan/$id'
    | '/desa/$slug/warga/booking'
    | '/desa/$slug/warga/chat'
    | '/desa/$slug/warga/laporan'
    | '/desa/$slug/warga/life-events'
    | '/desa/$slug/warga/login'
    | '/desa/$slug/warga/profil'
    | '/desa/$slug/warga/surat'
    | '/platform/desa/$desaId/administrasi'
    | '/platform/desa/$desaId/agen'
    | '/platform/desa/$desaId/bansos'
    | '/platform/desa/$desaId/bencana'
    | '/platform/desa/$desaId/booking'
    | '/platform/desa/$desaId/channel'
    | '/platform/desa/$desaId/custom-tools'
    | '/platform/desa/$desaId/dokumen'
    | '/platform/desa/$desaId/draft-surat'
    | '/platform/desa/$desaId/ekonomi'
    | '/platform/desa/$desaId/informasi'
    | '/platform/desa/$desaId/jabatan'
    | '/platform/desa/$desaId/kelembagaan'
    | '/platform/desa/$desaId/kepegawaian'
    | '/platform/desa/$desaId/kependudukan'
    | '/platform/desa/$desaId/kepribadian-ai'
    | '/platform/desa/$desaId/kesehatan'
    | '/platform/desa/$desaId/ketertiban'
    | '/platform/desa/$desaId/keuangan'
    | '/platform/desa/$desaId/laporan'
    | '/platform/desa/$desaId/life-events'
    | '/platform/desa/$desaId/log-aktivitas'
    | '/platform/desa/$desaId/memory'
    | '/platform/desa/$desaId/musrenbang'
    | '/platform/desa/$desaId/panduan'
    | '/platform/desa/$desaId/pembangunan'
    | '/platform/desa/$desaId/pemilihan'
    | '/platform/desa/$desaId/pendidikan'
    | '/platform/desa/$desaId/pengantar-wilayah'
    | '/platform/desa/$desaId/pengaturan'
    | '/platform/desa/$desaId/percakapan'
    | '/platform/desa/$desaId/pertanahan'
    | '/platform/desa/$desaId/profil-desa'
    | '/platform/desa/$desaId/riwayat'
    | '/platform/desa/$desaId/staff'
    | '/platform/desa/$desaId/statistik'
    | '/platform/desa/$desaId/surat'
    | '/platform/desa/$desaId/template-surat'
    | '/platform/desa/$desaId/test-ai'
    | '/platform/desa/$desaId/tools'
    | '/desa/$slug/dashboard'
    | '/desa/$slug/laporan'
    | '/desa/$slug/warga'
    | '/platform/desa/$desaId'
  id:
    | '__root__'
    | '/'
    | '/dashboard'
    | '/dev'
    | '/platform'
    | '/staff'
    | '/complete-profile'
    | '/login'
    | '/narasi'
    | '/parkir'
    | '/pilih-desa'
    | '/privasi'
    | '/task-inventory'
    | '/dashboard/desa'
    | '/platform/desa'
    | '/warga/$slug'
    | '/dev/agent-swarm'
    | '/dev/ai-flow'
    | '/dev/ai-routing'
    | '/dev/api-keys'
    | '/dev/code-graph'
    | '/dev/db-schema'
    | '/dev/docs'
    | '/dev/file-health'
    | '/dev/handler-evolution'
    | '/dev/observability'
    | '/dev/wa-repair-budget'
    | '/platform/integrasi-desa'
    | '/platform/log-aktivitas'
    | '/platform/panduan'
    | '/platform/pengaturan'
    | '/platform/pengguna'
    | '/platform/tiket'
    | '/platform/whatsapp-server'
    | '/platform/workers'
    | '/verify/$kode'
    | '/warga/pilih-desa'
    | '/dashboard/'
    | '/dev/'
    | '/platform/'
    | '/desa/$slug/dashboard'
    | '/desa/$slug/laporan'
    | '/desa/$slug/warga'
    | '/platform/desa/$desaId'
    | '/desa/$slug/booking'
    | '/desa/$slug/overview'
    | '/desa/$slug/transparansi'
    | '/desa/$slug/verifikasi-ktp'
    | '/dashboard/desa/'
    | '/desa/$slug/'
    | '/platform/desa/'
    | '/desa/$slug/dashboard/administrasi'
    | '/desa/$slug/dashboard/agen'
    | '/desa/$slug/dashboard/bansos'
    | '/desa/$slug/dashboard/bencana'
    | '/desa/$slug/dashboard/booking'
    | '/desa/$slug/dashboard/channel'
    | '/desa/$slug/dashboard/custom-tools'
    | '/desa/$slug/dashboard/dokumen'
    | '/desa/$slug/dashboard/draft-surat'
    | '/desa/$slug/dashboard/ekonomi'
    | '/desa/$slug/dashboard/informasi'
    | '/desa/$slug/dashboard/jabatan'
    | '/desa/$slug/dashboard/kelembagaan'
    | '/desa/$slug/dashboard/kepegawaian'
    | '/desa/$slug/dashboard/kependudukan'
    | '/desa/$slug/dashboard/kepribadian-ai'
    | '/desa/$slug/dashboard/kesehatan'
    | '/desa/$slug/dashboard/ketertiban'
    | '/desa/$slug/dashboard/keuangan'
    | '/desa/$slug/dashboard/laporan'
    | '/desa/$slug/dashboard/life-events'
    | '/desa/$slug/dashboard/log-aktivitas'
    | '/desa/$slug/dashboard/memory'
    | '/desa/$slug/dashboard/musrenbang'
    | '/desa/$slug/dashboard/panduan'
    | '/desa/$slug/dashboard/pembangunan'
    | '/desa/$slug/dashboard/pemilihan'
    | '/desa/$slug/dashboard/pendidikan'
    | '/desa/$slug/dashboard/pengantar-wilayah'
    | '/desa/$slug/dashboard/pengaturan'
    | '/desa/$slug/dashboard/percakapan'
    | '/desa/$slug/dashboard/pertanahan'
    | '/desa/$slug/dashboard/profil-desa'
    | '/desa/$slug/dashboard/riwayat'
    | '/desa/$slug/dashboard/staff'
    | '/desa/$slug/dashboard/statistik'
    | '/desa/$slug/dashboard/surat'
    | '/desa/$slug/dashboard/template-surat'
    | '/desa/$slug/dashboard/test-ai'
    | '/desa/$slug/dashboard/tools'
    | '/desa/$slug/form/$kode'
    | '/desa/$slug/laporan/$id'
    | '/desa/$slug/warga/booking'
    | '/desa/$slug/warga/chat'
    | '/desa/$slug/warga/laporan'
    | '/desa/$slug/warga/life-events'
    | '/desa/$slug/warga/login'
    | '/desa/$slug/warga/profil'
    | '/desa/$slug/warga/surat'
    | '/platform/desa/$desaId/administrasi'
    | '/platform/desa/$desaId/agen'
    | '/platform/desa/$desaId/bansos'
    | '/platform/desa/$desaId/bencana'
    | '/platform/desa/$desaId/booking'
    | '/platform/desa/$desaId/channel'
    | '/platform/desa/$desaId/custom-tools'
    | '/platform/desa/$desaId/dokumen'
    | '/platform/desa/$desaId/draft-surat'
    | '/platform/desa/$desaId/ekonomi'
    | '/platform/desa/$desaId/informasi'
    | '/platform/desa/$desaId/jabatan'
    | '/platform/desa/$desaId/kelembagaan'
    | '/platform/desa/$desaId/kepegawaian'
    | '/platform/desa/$desaId/kependudukan'
    | '/platform/desa/$desaId/kepribadian-ai'
    | '/platform/desa/$desaId/kesehatan'
    | '/platform/desa/$desaId/ketertiban'
    | '/platform/desa/$desaId/keuangan'
    | '/platform/desa/$desaId/laporan'
    | '/platform/desa/$desaId/life-events'
    | '/platform/desa/$desaId/log-aktivitas'
    | '/platform/desa/$desaId/memory'
    | '/platform/desa/$desaId/musrenbang'
    | '/platform/desa/$desaId/panduan'
    | '/platform/desa/$desaId/pembangunan'
    | '/platform/desa/$desaId/pemilihan'
    | '/platform/desa/$desaId/pendidikan'
    | '/platform/desa/$desaId/pengantar-wilayah'
    | '/platform/desa/$desaId/pengaturan'
    | '/platform/desa/$desaId/percakapan'
    | '/platform/desa/$desaId/pertanahan'
    | '/platform/desa/$desaId/profil-desa'
    | '/platform/desa/$desaId/riwayat'
    | '/platform/desa/$desaId/staff'
    | '/platform/desa/$desaId/statistik'
    | '/platform/desa/$desaId/surat'
    | '/platform/desa/$desaId/template-surat'
    | '/platform/desa/$desaId/test-ai'
    | '/platform/desa/$desaId/tools'
    | '/desa/$slug/dashboard/'
    | '/desa/$slug/laporan/'
    | '/desa/$slug/warga/'
    | '/platform/desa/$desaId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  DashboardRouteRoute: typeof DashboardRouteRouteWithChildren
  DevRouteRoute: typeof DevRouteRouteWithChildren
  PlatformRouteRoute: typeof PlatformRouteRouteWithChildren
  StaffRouteRoute: typeof StaffRouteRoute
  CompleteProfileRoute: typeof CompleteProfileRoute
  LoginRoute: typeof LoginRoute
  NarasiRoute: typeof NarasiRoute
  ParkirRoute: typeof ParkirRoute
  PilihDesaRoute: typeof PilihDesaRoute
  PrivasiRoute: typeof PrivasiRoute
  TaskInventoryRoute: typeof TaskInventoryRoute
  WargaSlugRouteRoute: typeof WargaSlugRouteRoute
  VerifyKodeRoute: typeof VerifyKodeRoute
  WargaPilihDesaRoute: typeof WargaPilihDesaRoute
  DesaSlugDashboardRouteRoute: typeof DesaSlugDashboardRouteRouteWithChildren
  DesaSlugLaporanRouteRoute: typeof DesaSlugLaporanRouteRouteWithChildren
  DesaSlugWargaRouteRoute: typeof DesaSlugWargaRouteRouteWithChildren
  DesaSlugBookingRoute: typeof DesaSlugBookingRoute
  DesaSlugOverviewRoute: typeof DesaSlugOverviewRoute
  DesaSlugTransparansiRoute: typeof DesaSlugTransparansiRoute
  DesaSlugVerifikasiKtpRoute: typeof DesaSlugVerifikasiKtpRoute
  DesaSlugIndexRoute: typeof DesaSlugIndexRoute
  DesaSlugFormKodeRoute: typeof DesaSlugFormKodeRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/task-inventory': {
      id: '/task-inventory'
      path: '/task-inventory'
      fullPath: '/task-inventory'
      preLoaderRoute: typeof TaskInventoryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privasi': {
      id: '/privasi'
      path: '/privasi'
      fullPath: '/privasi'
      preLoaderRoute: typeof PrivasiRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pilih-desa': {
      id: '/pilih-desa'
      path: '/pilih-desa'
      fullPath: '/pilih-desa'
      preLoaderRoute: typeof PilihDesaRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/parkir': {
      id: '/parkir'
      path: '/parkir'
      fullPath: '/parkir'
      preLoaderRoute: typeof ParkirRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/narasi': {
      id: '/narasi'
      path: '/narasi'
      fullPath: '/narasi'
      preLoaderRoute: typeof NarasiRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/complete-profile': {
      id: '/complete-profile'
      path: '/complete-profile'
      fullPath: '/complete-profile'
      preLoaderRoute: typeof CompleteProfileRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/staff': {
      id: '/staff'
      path: '/staff'
      fullPath: '/staff'
      preLoaderRoute: typeof StaffRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/platform': {
      id: '/platform'
      path: '/platform'
      fullPath: '/platform'
      preLoaderRoute: typeof PlatformRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dev': {
      id: '/dev'
      path: '/dev'
      fullPath: '/dev'
      preLoaderRoute: typeof DevRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard': {
      id: '/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/platform/': {
      id: '/platform/'
      path: '/'
      fullPath: '/platform/'
      preLoaderRoute: typeof PlatformIndexRouteImport
      parentRoute: typeof PlatformRouteRoute
    }
    '/dev/': {
      id: '/dev/'
      path: '/'
      fullPath: '/dev/'
      preLoaderRoute: typeof DevIndexRouteImport
      parentRoute: typeof DevRouteRoute
    }
    '/dashboard/': {
      id: '/dashboard/'
      path: '/'
      fullPath: '/dashboard/'
      preLoaderRoute: typeof DashboardIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/warga/pilih-desa': {
      id: '/warga/pilih-desa'
      path: '/warga/pilih-desa'
      fullPath: '/warga/pilih-desa'
      preLoaderRoute: typeof WargaPilihDesaRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/verify/$kode': {
      id: '/verify/$kode'
      path: '/verify/$kode'
      fullPath: '/verify/$kode'
      preLoaderRoute: typeof VerifyKodeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/platform/workers': {
      id: '/platform/workers'
      path: '/workers'
      fullPath: '/platform/workers'
      preLoaderRoute: typeof PlatformWorkersRouteImport
      parentRoute: typeof PlatformRouteRoute
    }
    '/platform/whatsapp-server': {
      id: '/platform/whatsapp-server'
      path: '/whatsapp-server'
      fullPath: '/platform/whatsapp-server'
      preLoaderRoute: typeof PlatformWhatsappServerRouteImport
      parentRoute: typeof PlatformRouteRoute
    }
    '/platform/tiket': {
      id: '/platform/tiket'
      path: '/tiket'
      fullPath: '/platform/tiket'
      preLoaderRoute: typeof PlatformTiketRouteImport
      parentRoute: typeof PlatformRouteRoute
    }
    '/platform/pengguna': {
      id: '/platform/pengguna'
      path: '/pengguna'
      fullPath: '/platform/pengguna'
      preLoaderRoute: typeof PlatformPenggunaRouteImport
      parentRoute: typeof PlatformRouteRoute
    }
    '/platform/pengaturan': {
      id: '/platform/pengaturan'
      path: '/pengaturan'
      fullPath: '/platform/pengaturan'
      preLoaderRoute: typeof PlatformPengaturanRouteImport
      parentRoute: typeof PlatformRouteRoute
    }
    '/platform/panduan': {
      id: '/platform/panduan'
      path: '/panduan'
      fullPath: '/platform/panduan'
      preLoaderRoute: typeof PlatformPanduanRouteImport
      parentRoute: typeof PlatformRouteRoute
    }
    '/platform/log-aktivitas': {
      id: '/platform/log-aktivitas'
      path: '/log-aktivitas'
      fullPath: '/platform/log-aktivitas'
      preLoaderRoute: typeof PlatformLogAktivitasRouteImport
      parentRoute: typeof PlatformRouteRoute
    }
    '/platform/integrasi-desa': {
      id: '/platform/integrasi-desa'
      path: '/integrasi-desa'
      fullPath: '/platform/integrasi-desa'
      preLoaderRoute: typeof PlatformIntegrasiDesaRouteImport
      parentRoute: typeof PlatformRouteRoute
    }
    '/dev/wa-repair-budget': {
      id: '/dev/wa-repair-budget'
      path: '/wa-repair-budget'
      fullPath: '/dev/wa-repair-budget'
      preLoaderRoute: typeof DevWaRepairBudgetRouteImport
      parentRoute: typeof DevRouteRoute
    }
    '/dev/observability': {
      id: '/dev/observability'
      path: '/observability'
      fullPath: '/dev/observability'
      preLoaderRoute: typeof DevObservabilityRouteImport
      parentRoute: typeof DevRouteRoute
    }
    '/dev/handler-evolution': {
      id: '/dev/handler-evolution'
      path: '/handler-evolution'
      fullPath: '/dev/handler-evolution'
      preLoaderRoute: typeof DevHandlerEvolutionRouteImport
      parentRoute: typeof DevRouteRoute
    }
    '/dev/file-health': {
      id: '/dev/file-health'
      path: '/file-health'
      fullPath: '/dev/file-health'
      preLoaderRoute: typeof DevFileHealthRouteImport
      parentRoute: typeof DevRouteRoute
    }
    '/dev/docs': {
      id: '/dev/docs'
      path: '/docs'
      fullPath: '/dev/docs'
      preLoaderRoute: typeof DevDocsRouteImport
      parentRoute: typeof DevRouteRoute
    }
    '/dev/db-schema': {
      id: '/dev/db-schema'
      path: '/db-schema'
      fullPath: '/dev/db-schema'
      preLoaderRoute: typeof DevDbSchemaRouteImport
      parentRoute: typeof DevRouteRoute
    }
    '/dev/code-graph': {
      id: '/dev/code-graph'
      path: '/code-graph'
      fullPath: '/dev/code-graph'
      preLoaderRoute: typeof DevCodeGraphRouteImport
      parentRoute: typeof DevRouteRoute
    }
    '/dev/api-keys': {
      id: '/dev/api-keys'
      path: '/api-keys'
      fullPath: '/dev/api-keys'
      preLoaderRoute: typeof DevApiKeysRouteImport
      parentRoute: typeof DevRouteRoute
    }
    '/dev/ai-routing': {
      id: '/dev/ai-routing'
      path: '/ai-routing'
      fullPath: '/dev/ai-routing'
      preLoaderRoute: typeof DevAiRoutingRouteImport
      parentRoute: typeof DevRouteRoute
    }
    '/dev/ai-flow': {
      id: '/dev/ai-flow'
      path: '/ai-flow'
      fullPath: '/dev/ai-flow'
      preLoaderRoute: typeof DevAiFlowRouteImport
      parentRoute: typeof DevRouteRoute
    }
    '/dev/agent-swarm': {
      id: '/dev/agent-swarm'
      path: '/agent-swarm'
      fullPath: '/dev/agent-swarm'
      preLoaderRoute: typeof DevAgentSwarmRouteImport
      parentRoute: typeof DevRouteRoute
    }
    '/warga/$slug': {
      id: '/warga/$slug'
      path: '/warga/$slug'
      fullPath: '/warga/$slug'
      preLoaderRoute: typeof WargaSlugRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/platform/desa': {
      id: '/platform/desa'
      path: '/desa'
      fullPath: '/platform/desa'
      preLoaderRoute: typeof PlatformDesaRouteRouteImport
      parentRoute: typeof PlatformRouteRoute
    }
    '/dashboard/desa': {
      id: '/dashboard/desa'
      path: '/desa'
      fullPath: '/dashboard/desa'
      preLoaderRoute: typeof DashboardDesaRouteRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/platform/desa/': {
      id: '/platform/desa/'
      path: '/'
      fullPath: '/platform/desa/'
      preLoaderRoute: typeof PlatformDesaIndexRouteImport
      parentRoute: typeof PlatformDesaRouteRoute
    }
    '/desa/$slug/': {
      id: '/desa/$slug/'
      path: '/desa/$slug'
      fullPath: '/desa/$slug/'
      preLoaderRoute: typeof DesaSlugIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/desa/': {
      id: '/dashboard/desa/'
      path: '/'
      fullPath: '/dashboard/desa/'
      preLoaderRoute: typeof DashboardDesaIndexRouteImport
      parentRoute: typeof DashboardDesaRouteRoute
    }
    '/desa/$slug/verifikasi-ktp': {
      id: '/desa/$slug/verifikasi-ktp'
      path: '/desa/$slug/verifikasi-ktp'
      fullPath: '/desa/$slug/verifikasi-ktp'
      preLoaderRoute: typeof DesaSlugVerifikasiKtpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/desa/$slug/transparansi': {
      id: '/desa/$slug/transparansi'
      path: '/desa/$slug/transparansi'
      fullPath: '/desa/$slug/transparansi'
      preLoaderRoute: typeof DesaSlugTransparansiRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/desa/$slug/overview': {
      id: '/desa/$slug/overview'
      path: '/desa/$slug/overview'
      fullPath: '/desa/$slug/overview'
      preLoaderRoute: typeof DesaSlugOverviewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/desa/$slug/booking': {
      id: '/desa/$slug/booking'
      path: '/desa/$slug/booking'
      fullPath: '/desa/$slug/booking'
      preLoaderRoute: typeof DesaSlugBookingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/platform/desa/$desaId': {
      id: '/platform/desa/$desaId'
      path: '/$desaId'
      fullPath: '/platform/desa/$desaId'
      preLoaderRoute: typeof PlatformDesaDesaIdRouteRouteImport
      parentRoute: typeof PlatformDesaRouteRoute
    }
    '/desa/$slug/warga': {
      id: '/desa/$slug/warga'
      path: '/desa/$slug/warga'
      fullPath: '/desa/$slug/warga'
      preLoaderRoute: typeof DesaSlugWargaRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/desa/$slug/laporan': {
      id: '/desa/$slug/laporan'
      path: '/desa/$slug/laporan'
      fullPath: '/desa/$slug/laporan'
      preLoaderRoute: typeof DesaSlugLaporanRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/desa/$slug/dashboard': {
      id: '/desa/$slug/dashboard'
      path: '/desa/$slug/dashboard'
      fullPath: '/desa/$slug/dashboard'
      preLoaderRoute: typeof DesaSlugDashboardRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/platform/desa/$desaId/': {
      id: '/platform/desa/$desaId/'
      path: '/'
      fullPath: '/platform/desa/$desaId/'
      preLoaderRoute: typeof PlatformDesaDesaIdIndexRouteImport
      parentRoute: typeof PlatformDesaDesaIdRouteRoute
    }
    '/desa/$slug/warga/': {
      id: '/desa/$slug/warga/'
      path: '/'
      fullPath: '/desa/$slug/warga/'
      preLoaderRoute: typeof DesaSlugWargaIndexRouteImport
      parentRoute: typeof DesaSlugWargaRouteRoute
    }
    '/desa/$slug/laporan/': {
      id: '/desa/$slug/laporan/'
      path: '/'
      fullPath: '/desa/$slug/laporan/'
      preLoaderRoute: typeof DesaSlugLaporanIndexRouteImport
      parentRoute: typeof DesaSlugLaporanRouteRoute
    }
    '/desa/$slug/dashboard/': {
      id: '/desa/$slug/dashboard/'
      path: '/'
      fullPath: '/desa/$slug/dashboard/'
      preLoaderRoute: typeof DesaSlugDashboardIndexRouteImport
      parentRoute: typeof DesaSlugDashboardRouteRoute
    }
    '/platform/desa/$desaId/tools': {
      id: '/platform/desa/$desaId/tools'
      path: '/tools'
      fullPath: '/platform/desa/$desaId/tools'
      preLoaderRoute: typeof PlatformDesaDesaIdToolsRouteImport
      parentRoute: typeof PlatformDesaDesaIdRouteRoute
    }
    '/platform/desa/$desaId/test-ai': {
      id: '/platform/desa/$desaId/test-ai'
      path: '/test-ai'
      fullPath: '/platform/desa/$desaId/test-ai'
      preLoaderRoute: typeof PlatformDesaDesaIdTestAiRouteImport
      parentRoute: typeof PlatformDesaDesaIdRouteRoute
    }
    '/platform/desa/$desaId/template-surat': {
      id: '/platform/desa/$desaId/template-surat'
      path: '/template-surat'
      fullPath: '/platform/desa/$desaId/template-surat'
      preLoaderRoute: typeof PlatformDesaDesaIdTemplateSuratRouteImport
      parentRoute: typeof PlatformDesaDesaIdRouteRoute
    }
    '/platform/desa/$desaId/surat': {
      id: '/platform/desa/$desaId/surat'
      path: '/surat'
      fullPath: '/platform/desa/$desaId/surat'
      preLoaderRoute: typeof PlatformDesaDesaIdSuratRouteImport
      parentRoute: typeof PlatformDesaDesaIdRouteRoute
    }
    '/platform/desa/$desaId/statistik': {
      id: '/platform/desa/$desaId/statistik'
      path: '/statistik'
      fullPath: '/platform/desa/$desaId/statistik'
      preLoaderRoute: typeof PlatformDesaDesaIdStatistikRouteImport
      parentRoute: typeof PlatformDesaDesaIdRouteRoute
    }
    '/platform/desa/$desaId/staff': {
      id: '/platform/desa/$desaId/staff'
      path: '/staff'
      fullPath: '/platform/desa/$desaId/staff'
      preLoaderRoute: typeof PlatformDesaDesaIdStaffRouteImport
      parentRoute: typeof PlatformDesaDesaIdRouteRoute
    }
    '/platform/desa/$desaId/riwayat': {
      id: '/platform/desa/$desaId/riwayat'
      path: '/riwayat'
      fullPath: '/platform/desa/$desaId/riwayat'
      preLoaderRoute: typeof PlatformDesaDesaIdRiwayatRouteImport
      parentRoute: typeof PlatformDesaDesaIdRouteRoute
    }
    '/platform/desa/$desaId/profil-desa': {
      id: '/platform/desa/$desaId/profil-desa'
      path: '/profil-desa'
      fullPath: '/platform/desa/$desaId/profil-desa'
      preLoaderRoute: typeof PlatformDesaDesaIdProfilDesaRouteImport
      parentRoute: typeof PlatformDesaDesaIdRouteRoute
    }
    '/platform/desa/$desaId/pertanahan': {
      id: '/platform/desa/$desaId/pertanahan'
      path: '/pertanahan'
      fullPath: '/platform/desa/$desaId/pertanahan'
      preLoaderRoute: typeof PlatformDesaDesaIdPertanahanRouteImport
      parentRoute: typeof PlatformDesaDesaIdRouteRoute
    }
    '/platform/desa/$desaId/percakapan': {
      id: '/platform/desa/$desaId/percakapan'
      path: '/percakapan'
      fullPath: '/platform/desa/$desaId/percakapan'
      preLoaderRoute: typeof PlatformDesaDesaIdPercakapanRouteImport
      parentRoute: typeof PlatformDesaDesaIdRouteRoute
    }
    '/platform/desa/$desaId/pengaturan': {
      id: '/platform/desa/$desaId/pengaturan'
      path: '/pengaturan'
      fullPath: '/platform/desa/$desaId/pengaturan'
      preLoaderRoute: typeof PlatformDesaDesaIdPengaturanRouteImport
      parentRoute: typeof PlatformDesaDesaIdRouteRoute
    }
    '/platform/desa/$desaId/pengantar-wilayah': {
      id: '/platform/desa/$desaId/pengantar-wilayah'
      path: '/pengantar-wilayah'
      fullPath: '/platform/desa/$desaId/pengantar-wilayah'
      preLoaderRoute: typeof PlatformDesaDesaIdPengantarWilayahRouteImport
      parentRoute: typeof PlatformDesaDesaIdRouteRoute
    }
    '/platform/desa/$desaId/pendidikan': {
      id: '/platform/desa/$desaId/pendidikan'
      path: '/pendidikan'
      fullPath: '/platform/desa/$desaId/pendidikan'
      preLoaderRoute: typeof PlatformDesaDesaIdPendidikanRouteImport
      parentRoute: typeof PlatformDesaDesaIdRouteRoute
    }
    '/platform/desa/$desaId/pemilihan': {
      id: '/platform/desa/$desaId/pemilihan'
      path: '/pemilihan'
      fullPath: '/platform/desa/$desaId/pemilihan'
      preLoaderRoute: typeof PlatformDesaDesaIdPemilihanRouteImport
      parentRoute: typeof PlatformDesaDesaIdRouteRoute
    }
    '/platform/desa/$desaId/pembangunan': {
      id: '/platform/desa/$desaId/pembangunan'
      path: '/pembangunan'
      fullPath: '/platform/desa/$desaId/pembangunan'
      preLoaderRoute: typeof PlatformDesaDesaIdPembangunanRouteImport
      parentRoute: typeof PlatformDesaDesaIdRouteRoute
    }
    '/platform/desa/$desaId/panduan': {
      id: '/platform/desa/$desaId/panduan'
      path: '/panduan'
      fullPath: '/platform/desa/$desaId/panduan'
      preLoaderRoute: typeof PlatformDesaDesaIdPanduanRouteImport
      parentRoute: typeof PlatformDesaDesaIdRouteRoute
    }
    '/platform/desa/$desaId/musrenbang': {
      id: '/platform/desa/$desaId/musrenbang'
      path: '/musrenbang'
      fullPath: '/platform/desa/$desaId/musrenbang'
      preLoaderRoute: typeof PlatformDesaDesaIdMusrenbangRouteImport
      parentRoute: typeof PlatformDesaDesaIdRouteRoute
    }
    '/platform/desa/$desaId/memory': {
      id: '/platform/desa/$desaId/memory'
      path: '/memory'
      fullPath: '/platform/desa/$desaId/memory'
      preLoaderRoute: typeof PlatformDesaDesaIdMemoryRouteImport
      parentRoute: typeof PlatformDesaDesaIdRouteRoute
    }
    '/platform/desa/$desaId/log-aktivitas': {
      id: '/platform/desa/$desaId/log-aktivitas'
      path: '/log-aktivitas'
      fullPath: '/platform/desa/$desaId/log-aktivitas'
      preLoaderRoute: typeof PlatformDesaDesaIdLogAktivitasRouteImport
      parentRoute: typeof PlatformDesaDesaIdRouteRoute
    }
    '/platform/desa/$desaId/life-events': {
      id: '/platform/desa/$desaId/life-events'
      path: '/life-events'
      fullPath: '/platform/desa/$desaId/life-events'
      preLoaderRoute: typeof PlatformDesaDesaIdLifeEventsRouteImport
      parentRoute: typeof PlatformDesaDesaIdRouteRoute
    }
    '/platform/desa/$desaId/laporan': {
      id: '/platform/desa/$desaId/laporan'
      path: '/laporan'
      fullPath: '/platform/desa/$desaId/laporan'
      preLoaderRoute: typeof PlatformDesaDesaIdLaporanRouteImport
      parentRoute: typeof PlatformDesaDesaIdRouteRoute
    }
    '/platform/desa/$desaId/keuangan': {
      id: '/platform/desa/$desaId/keuangan'
      path: '/keuangan'
      fullPath: '/platform/desa/$desaId/keuangan'
      preLoaderRoute: typeof PlatformDesaDesaIdKeuanganRouteImport
      parentRoute: typeof PlatformDesaDesaIdRouteRoute
    }
    '/platform/desa/$desaId/ketertiban': {
      id: '/platform/desa/$desaId/ketertiban'
      path: '/ketertiban'
      fullPath: '/platform/desa/$desaId/ketertiban'
      preLoaderRoute: typeof PlatformDesaDesaIdKetertibanRouteImport
      parentRoute: typeof PlatformDesaDesaIdRouteRoute
    }
    '/platform/desa/$desaId/kesehatan': {
      id: '/platform/desa/$desaId/kesehatan'
      path: '/kesehatan'
      fullPath: '/platform/desa/$desaId/kesehatan'
      preLoaderRoute: typeof PlatformDesaDesaIdKesehatanRouteImport
      parentRoute: typeof PlatformDesaDesaIdRouteRoute
    }
    '/platform/desa/$desaId/kepribadian-ai': {
      id: '/platform/desa/$desaId/kepribadian-ai'
      path: '/kepribadian-ai'
      fullPath: '/platform/desa/$desaId/kepribadian-ai'
      preLoaderRoute: typeof PlatformDesaDesaIdKepribadianAiRouteImport
      parentRoute: typeof PlatformDesaDesaIdRouteRoute
    }
    '/platform/desa/$desaId/kependudukan': {
      id: '/platform/desa/$desaId/kependudukan'
      path: '/kependudukan'
      fullPath: '/platform/desa/$desaId/kependudukan'
      preLoaderRoute: typeof PlatformDesaDesaIdKependudukanRouteImport
      parentRoute: typeof PlatformDesaDesaIdRouteRoute
    }
    '/platform/desa/$desaId/kepegawaian': {
      id: '/platform/desa/$desaId/kepegawaian'
      path: '/kepegawaian'
      fullPath: '/platform/desa/$desaId/kepegawaian'
      preLoaderRoute: typeof PlatformDesaDesaIdKepegawaianRouteImport
      parentRoute: typeof PlatformDesaDesaIdRouteRoute
    }
    '/platform/desa/$desaId/kelembagaan': {
      id: '/platform/desa/$desaId/kelembagaan'
      path: '/kelembagaan'
      fullPath: '/platform/desa/$desaId/kelembagaan'
      preLoaderRoute: typeof PlatformDesaDesaIdKelembagaanRouteImport
      parentRoute: typeof PlatformDesaDesaIdRouteRoute
    }
    '/platform/desa/$desaId/jabatan': {
      id: '/platform/desa/$desaId/jabatan'
      path: '/jabatan'
      fullPath: '/platform/desa/$desaId/jabatan'
      preLoaderRoute: typeof PlatformDesaDesaIdJabatanRouteImport
      parentRoute: typeof PlatformDesaDesaIdRouteRoute
    }
    '/platform/desa/$desaId/informasi': {
      id: '/platform/desa/$desaId/informasi'
      path: '/informasi'
      fullPath: '/platform/desa/$desaId/informasi'
      preLoaderRoute: typeof PlatformDesaDesaIdInformasiRouteImport
      parentRoute: typeof PlatformDesaDesaIdRouteRoute
    }
    '/platform/desa/$desaId/ekonomi': {
      id: '/platform/desa/$desaId/ekonomi'
      path: '/ekonomi'
      fullPath: '/platform/desa/$desaId/ekonomi'
      preLoaderRoute: typeof PlatformDesaDesaIdEkonomiRouteImport
      parentRoute: typeof PlatformDesaDesaIdRouteRoute
    }
    '/platform/desa/$desaId/draft-surat': {
      id: '/platform/desa/$desaId/draft-surat'
      path: '/draft-surat'
      fullPath: '/platform/desa/$desaId/draft-surat'
      preLoaderRoute: typeof PlatformDesaDesaIdDraftSuratRouteImport
      parentRoute: typeof PlatformDesaDesaIdRouteRoute
    }
    '/platform/desa/$desaId/dokumen': {
      id: '/platform/desa/$desaId/dokumen'
      path: '/dokumen'
      fullPath: '/platform/desa/$desaId/dokumen'
      preLoaderRoute: typeof PlatformDesaDesaIdDokumenRouteImport
      parentRoute: typeof PlatformDesaDesaIdRouteRoute
    }
    '/platform/desa/$desaId/custom-tools': {
      id: '/platform/desa/$desaId/custom-tools'
      path: '/custom-tools'
      fullPath: '/platform/desa/$desaId/custom-tools'
      preLoaderRoute: typeof PlatformDesaDesaIdCustomToolsRouteImport
      parentRoute: typeof PlatformDesaDesaIdRouteRoute
    }
    '/platform/desa/$desaId/channel': {
      id: '/platform/desa/$desaId/channel'
      path: '/channel'
      fullPath: '/platform/desa/$desaId/channel'
      preLoaderRoute: typeof PlatformDesaDesaIdChannelRouteImport
      parentRoute: typeof PlatformDesaDesaIdRouteRoute
    }
    '/platform/desa/$desaId/booking': {
      id: '/platform/desa/$desaId/booking'
      path: '/booking'
      fullPath: '/platform/desa/$desaId/booking'
      preLoaderRoute: typeof PlatformDesaDesaIdBookingRouteImport
      parentRoute: typeof PlatformDesaDesaIdRouteRoute
    }
    '/platform/desa/$desaId/bencana': {
      id: '/platform/desa/$desaId/bencana'
      path: '/bencana'
      fullPath: '/platform/desa/$desaId/bencana'
      preLoaderRoute: typeof PlatformDesaDesaIdBencanaRouteImport
      parentRoute: typeof PlatformDesaDesaIdRouteRoute
    }
    '/platform/desa/$desaId/bansos': {
      id: '/platform/desa/$desaId/bansos'
      path: '/bansos'
      fullPath: '/platform/desa/$desaId/bansos'
      preLoaderRoute: typeof PlatformDesaDesaIdBansosRouteImport
      parentRoute: typeof PlatformDesaDesaIdRouteRoute
    }
    '/platform/desa/$desaId/agen': {
      id: '/platform/desa/$desaId/agen'
      path: '/agen'
      fullPath: '/platform/desa/$desaId/agen'
      preLoaderRoute: typeof PlatformDesaDesaIdAgenRouteImport
      parentRoute: typeof PlatformDesaDesaIdRouteRoute
    }
    '/platform/desa/$desaId/administrasi': {
      id: '/platform/desa/$desaId/administrasi'
      path: '/administrasi'
      fullPath: '/platform/desa/$desaId/administrasi'
      preLoaderRoute: typeof PlatformDesaDesaIdAdministrasiRouteImport
      parentRoute: typeof PlatformDesaDesaIdRouteRoute
    }
    '/desa/$slug/warga/surat': {
      id: '/desa/$slug/warga/surat'
      path: '/surat'
      fullPath: '/desa/$slug/warga/surat'
      preLoaderRoute: typeof DesaSlugWargaSuratRouteImport
      parentRoute: typeof DesaSlugWargaRouteRoute
    }
    '/desa/$slug/warga/profil': {
      id: '/desa/$slug/warga/profil'
      path: '/profil'
      fullPath: '/desa/$slug/warga/profil'
      preLoaderRoute: typeof DesaSlugWargaProfilRouteImport
      parentRoute: typeof DesaSlugWargaRouteRoute
    }
    '/desa/$slug/warga/login': {
      id: '/desa/$slug/warga/login'
      path: '/login'
      fullPath: '/desa/$slug/warga/login'
      preLoaderRoute: typeof DesaSlugWargaLoginRouteImport
      parentRoute: typeof DesaSlugWargaRouteRoute
    }
    '/desa/$slug/warga/life-events': {
      id: '/desa/$slug/warga/life-events'
      path: '/life-events'
      fullPath: '/desa/$slug/warga/life-events'
      preLoaderRoute: typeof DesaSlugWargaLifeEventsRouteImport
      parentRoute: typeof DesaSlugWargaRouteRoute
    }
    '/desa/$slug/warga/laporan': {
      id: '/desa/$slug/warga/laporan'
      path: '/laporan'
      fullPath: '/desa/$slug/warga/laporan'
      preLoaderRoute: typeof DesaSlugWargaLaporanRouteImport
      parentRoute: typeof DesaSlugWargaRouteRoute
    }
    '/desa/$slug/warga/chat': {
      id: '/desa/$slug/warga/chat'
      path: '/chat'
      fullPath: '/desa/$slug/warga/chat'
      preLoaderRoute: typeof DesaSlugWargaChatRouteImport
      parentRoute: typeof DesaSlugWargaRouteRoute
    }
    '/desa/$slug/warga/booking': {
      id: '/desa/$slug/warga/booking'
      path: '/booking'
      fullPath: '/desa/$slug/warga/booking'
      preLoaderRoute: typeof DesaSlugWargaBookingRouteImport
      parentRoute: typeof DesaSlugWargaRouteRoute
    }
    '/desa/$slug/laporan/$id': {
      id: '/desa/$slug/laporan/$id'
      path: '/$id'
      fullPath: '/desa/$slug/laporan/$id'
      preLoaderRoute: typeof DesaSlugLaporanIdRouteImport
      parentRoute: typeof DesaSlugLaporanRouteRoute
    }
    '/desa/$slug/form/$kode': {
      id: '/desa/$slug/form/$kode'
      path: '/desa/$slug/form/$kode'
      fullPath: '/desa/$slug/form/$kode'
      preLoaderRoute: typeof DesaSlugFormKodeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/desa/$slug/dashboard/tools': {
      id: '/desa/$slug/dashboard/tools'
      path: '/tools'
      fullPath: '/desa/$slug/dashboard/tools'
      preLoaderRoute: typeof DesaSlugDashboardToolsRouteImport
      parentRoute: typeof DesaSlugDashboardRouteRoute
    }
    '/desa/$slug/dashboard/test-ai': {
      id: '/desa/$slug/dashboard/test-ai'
      path: '/test-ai'
      fullPath: '/desa/$slug/dashboard/test-ai'
      preLoaderRoute: typeof DesaSlugDashboardTestAiRouteImport
      parentRoute: typeof DesaSlugDashboardRouteRoute
    }
    '/desa/$slug/dashboard/template-surat': {
      id: '/desa/$slug/dashboard/template-surat'
      path: '/template-surat'
      fullPath: '/desa/$slug/dashboard/template-surat'
      preLoaderRoute: typeof DesaSlugDashboardTemplateSuratRouteImport
      parentRoute: typeof DesaSlugDashboardRouteRoute
    }
    '/desa/$slug/dashboard/surat': {
      id: '/desa/$slug/dashboard/surat'
      path: '/surat'
      fullPath: '/desa/$slug/dashboard/surat'
      preLoaderRoute: typeof DesaSlugDashboardSuratRouteImport
      parentRoute: typeof DesaSlugDashboardRouteRoute
    }
    '/desa/$slug/dashboard/statistik': {
      id: '/desa/$slug/dashboard/statistik'
      path: '/statistik'
      fullPath: '/desa/$slug/dashboard/statistik'
      preLoaderRoute: typeof DesaSlugDashboardStatistikRouteImport
      parentRoute: typeof DesaSlugDashboardRouteRoute
    }
    '/desa/$slug/dashboard/staff': {
      id: '/desa/$slug/dashboard/staff'
      path: '/staff'
      fullPath: '/desa/$slug/dashboard/staff'
      preLoaderRoute: typeof DesaSlugDashboardStaffRouteImport
      parentRoute: typeof DesaSlugDashboardRouteRoute
    }
    '/desa/$slug/dashboard/riwayat': {
      id: '/desa/$slug/dashboard/riwayat'
      path: '/riwayat'
      fullPath: '/desa/$slug/dashboard/riwayat'
      preLoaderRoute: typeof DesaSlugDashboardRiwayatRouteImport
      parentRoute: typeof DesaSlugDashboardRouteRoute
    }
    '/desa/$slug/dashboard/profil-desa': {
      id: '/desa/$slug/dashboard/profil-desa'
      path: '/profil-desa'
      fullPath: '/desa/$slug/dashboard/profil-desa'
      preLoaderRoute: typeof DesaSlugDashboardProfilDesaRouteImport
      parentRoute: typeof DesaSlugDashboardRouteRoute
    }
    '/desa/$slug/dashboard/pertanahan': {
      id: '/desa/$slug/dashboard/pertanahan'
      path: '/pertanahan'
      fullPath: '/desa/$slug/dashboard/pertanahan'
      preLoaderRoute: typeof DesaSlugDashboardPertanahanRouteImport
      parentRoute: typeof DesaSlugDashboardRouteRoute
    }
    '/desa/$slug/dashboard/percakapan': {
      id: '/desa/$slug/dashboard/percakapan'
      path: '/percakapan'
      fullPath: '/desa/$slug/dashboard/percakapan'
      preLoaderRoute: typeof DesaSlugDashboardPercakapanRouteImport
      parentRoute: typeof DesaSlugDashboardRouteRoute
    }
    '/desa/$slug/dashboard/pengaturan': {
      id: '/desa/$slug/dashboard/pengaturan'
      path: '/pengaturan'
      fullPath: '/desa/$slug/dashboard/pengaturan'
      preLoaderRoute: typeof DesaSlugDashboardPengaturanRouteImport
      parentRoute: typeof DesaSlugDashboardRouteRoute
    }
    '/desa/$slug/dashboard/pengantar-wilayah': {
      id: '/desa/$slug/dashboard/pengantar-wilayah'
      path: '/pengantar-wilayah'
      fullPath: '/desa/$slug/dashboard/pengantar-wilayah'
      preLoaderRoute: typeof DesaSlugDashboardPengantarWilayahRouteImport
      parentRoute: typeof DesaSlugDashboardRouteRoute
    }
    '/desa/$slug/dashboard/pendidikan': {
      id: '/desa/$slug/dashboard/pendidikan'
      path: '/pendidikan'
      fullPath: '/desa/$slug/dashboard/pendidikan'
      preLoaderRoute: typeof DesaSlugDashboardPendidikanRouteImport
      parentRoute: typeof DesaSlugDashboardRouteRoute
    }
    '/desa/$slug/dashboard/pemilihan': {
      id: '/desa/$slug/dashboard/pemilihan'
      path: '/pemilihan'
      fullPath: '/desa/$slug/dashboard/pemilihan'
      preLoaderRoute: typeof DesaSlugDashboardPemilihanRouteImport
      parentRoute: typeof DesaSlugDashboardRouteRoute
    }
    '/desa/$slug/dashboard/pembangunan': {
      id: '/desa/$slug/dashboard/pembangunan'
      path: '/pembangunan'
      fullPath: '/desa/$slug/dashboard/pembangunan'
      preLoaderRoute: typeof DesaSlugDashboardPembangunanRouteImport
      parentRoute: typeof DesaSlugDashboardRouteRoute
    }
    '/desa/$slug/dashboard/panduan': {
      id: '/desa/$slug/dashboard/panduan'
      path: '/panduan'
      fullPath: '/desa/$slug/dashboard/panduan'
      preLoaderRoute: typeof DesaSlugDashboardPanduanRouteImport
      parentRoute: typeof DesaSlugDashboardRouteRoute
    }
    '/desa/$slug/dashboard/musrenbang': {
      id: '/desa/$slug/dashboard/musrenbang'
      path: '/musrenbang'
      fullPath: '/desa/$slug/dashboard/musrenbang'
      preLoaderRoute: typeof DesaSlugDashboardMusrenbangRouteImport
      parentRoute: typeof DesaSlugDashboardRouteRoute
    }
    '/desa/$slug/dashboard/memory': {
      id: '/desa/$slug/dashboard/memory'
      path: '/memory'
      fullPath: '/desa/$slug/dashboard/memory'
      preLoaderRoute: typeof DesaSlugDashboardMemoryRouteImport
      parentRoute: typeof DesaSlugDashboardRouteRoute
    }
    '/desa/$slug/dashboard/log-aktivitas': {
      id: '/desa/$slug/dashboard/log-aktivitas'
      path: '/log-aktivitas'
      fullPath: '/desa/$slug/dashboard/log-aktivitas'
      preLoaderRoute: typeof DesaSlugDashboardLogAktivitasRouteImport
      parentRoute: typeof DesaSlugDashboardRouteRoute
    }
    '/desa/$slug/dashboard/life-events': {
      id: '/desa/$slug/dashboard/life-events'
      path: '/life-events'
      fullPath: '/desa/$slug/dashboard/life-events'
      preLoaderRoute: typeof DesaSlugDashboardLifeEventsRouteImport
      parentRoute: typeof DesaSlugDashboardRouteRoute
    }
    '/desa/$slug/dashboard/laporan': {
      id: '/desa/$slug/dashboard/laporan'
      path: '/laporan'
      fullPath: '/desa/$slug/dashboard/laporan'
      preLoaderRoute: typeof DesaSlugDashboardLaporanRouteImport
      parentRoute: typeof DesaSlugDashboardRouteRoute
    }
    '/desa/$slug/dashboard/keuangan': {
      id: '/desa/$slug/dashboard/keuangan'
      path: '/keuangan'
      fullPath: '/desa/$slug/dashboard/keuangan'
      preLoaderRoute: typeof DesaSlugDashboardKeuanganRouteImport
      parentRoute: typeof DesaSlugDashboardRouteRoute
    }
    '/desa/$slug/dashboard/ketertiban': {
      id: '/desa/$slug/dashboard/ketertiban'
      path: '/ketertiban'
      fullPath: '/desa/$slug/dashboard/ketertiban'
      preLoaderRoute: typeof DesaSlugDashboardKetertibanRouteImport
      parentRoute: typeof DesaSlugDashboardRouteRoute
    }
    '/desa/$slug/dashboard/kesehatan': {
      id: '/desa/$slug/dashboard/kesehatan'
      path: '/kesehatan'
      fullPath: '/desa/$slug/dashboard/kesehatan'
      preLoaderRoute: typeof DesaSlugDashboardKesehatanRouteImport
      parentRoute: typeof DesaSlugDashboardRouteRoute
    }
    '/desa/$slug/dashboard/kepribadian-ai': {
      id: '/desa/$slug/dashboard/kepribadian-ai'
      path: '/kepribadian-ai'
      fullPath: '/desa/$slug/dashboard/kepribadian-ai'
      preLoaderRoute: typeof DesaSlugDashboardKepribadianAiRouteImport
      parentRoute: typeof DesaSlugDashboardRouteRoute
    }
    '/desa/$slug/dashboard/kependudukan': {
      id: '/desa/$slug/dashboard/kependudukan'
      path: '/kependudukan'
      fullPath: '/desa/$slug/dashboard/kependudukan'
      preLoaderRoute: typeof DesaSlugDashboardKependudukanRouteImport
      parentRoute: typeof DesaSlugDashboardRouteRoute
    }
    '/desa/$slug/dashboard/kepegawaian': {
      id: '/desa/$slug/dashboard/kepegawaian'
      path: '/kepegawaian'
      fullPath: '/desa/$slug/dashboard/kepegawaian'
      preLoaderRoute: typeof DesaSlugDashboardKepegawaianRouteImport
      parentRoute: typeof DesaSlugDashboardRouteRoute
    }
    '/desa/$slug/dashboard/kelembagaan': {
      id: '/desa/$slug/dashboard/kelembagaan'
      path: '/kelembagaan'
      fullPath: '/desa/$slug/dashboard/kelembagaan'
      preLoaderRoute: typeof DesaSlugDashboardKelembagaanRouteImport
      parentRoute: typeof DesaSlugDashboardRouteRoute
    }
    '/desa/$slug/dashboard/jabatan': {
      id: '/desa/$slug/dashboard/jabatan'
      path: '/jabatan'
      fullPath: '/desa/$slug/dashboard/jabatan'
      preLoaderRoute: typeof DesaSlugDashboardJabatanRouteImport
      parentRoute: typeof DesaSlugDashboardRouteRoute
    }
    '/desa/$slug/dashboard/informasi': {
      id: '/desa/$slug/dashboard/informasi'
      path: '/informasi'
      fullPath: '/desa/$slug/dashboard/informasi'
      preLoaderRoute: typeof DesaSlugDashboardInformasiRouteImport
      parentRoute: typeof DesaSlugDashboardRouteRoute
    }
    '/desa/$slug/dashboard/ekonomi': {
      id: '/desa/$slug/dashboard/ekonomi'
      path: '/ekonomi'
      fullPath: '/desa/$slug/dashboard/ekonomi'
      preLoaderRoute: typeof DesaSlugDashboardEkonomiRouteImport
      parentRoute: typeof DesaSlugDashboardRouteRoute
    }
    '/desa/$slug/dashboard/draft-surat': {
      id: '/desa/$slug/dashboard/draft-surat'
      path: '/draft-surat'
      fullPath: '/desa/$slug/dashboard/draft-surat'
      preLoaderRoute: typeof DesaSlugDashboardDraftSuratRouteImport
      parentRoute: typeof DesaSlugDashboardRouteRoute
    }
    '/desa/$slug/dashboard/dokumen': {
      id: '/desa/$slug/dashboard/dokumen'
      path: '/dokumen'
      fullPath: '/desa/$slug/dashboard/dokumen'
      preLoaderRoute: typeof DesaSlugDashboardDokumenRouteImport
      parentRoute: typeof DesaSlugDashboardRouteRoute
    }
    '/desa/$slug/dashboard/custom-tools': {
      id: '/desa/$slug/dashboard/custom-tools'
      path: '/custom-tools'
      fullPath: '/desa/$slug/dashboard/custom-tools'
      preLoaderRoute: typeof DesaSlugDashboardCustomToolsRouteImport
      parentRoute: typeof DesaSlugDashboardRouteRoute
    }
    '/desa/$slug/dashboard/channel': {
      id: '/desa/$slug/dashboard/channel'
      path: '/channel'
      fullPath: '/desa/$slug/dashboard/channel'
      preLoaderRoute: typeof DesaSlugDashboardChannelRouteImport
      parentRoute: typeof DesaSlugDashboardRouteRoute
    }
    '/desa/$slug/dashboard/booking': {
      id: '/desa/$slug/dashboard/booking'
      path: '/booking'
      fullPath: '/desa/$slug/dashboard/booking'
      preLoaderRoute: typeof DesaSlugDashboardBookingRouteImport
      parentRoute: typeof DesaSlugDashboardRouteRoute
    }
    '/desa/$slug/dashboard/bencana': {
      id: '/desa/$slug/dashboard/bencana'
      path: '/bencana'
      fullPath: '/desa/$slug/dashboard/bencana'
      preLoaderRoute: typeof DesaSlugDashboardBencanaRouteImport
      parentRoute: typeof DesaSlugDashboardRouteRoute
    }
    '/desa/$slug/dashboard/bansos': {
      id: '/desa/$slug/dashboard/bansos'
      path: '/bansos'
      fullPath: '/desa/$slug/dashboard/bansos'
      preLoaderRoute: typeof DesaSlugDashboardBansosRouteImport
      parentRoute: typeof DesaSlugDashboardRouteRoute
    }
    '/desa/$slug/dashboard/agen': {
      id: '/desa/$slug/dashboard/agen'
      path: '/agen'
      fullPath: '/desa/$slug/dashboard/agen'
      preLoaderRoute: typeof DesaSlugDashboardAgenRouteImport
      parentRoute: typeof DesaSlugDashboardRouteRoute
    }
    '/desa/$slug/dashboard/administrasi': {
      id: '/desa/$slug/dashboard/administrasi'
      path: '/administrasi'
      fullPath: '/desa/$slug/dashboard/administrasi'
      preLoaderRoute: typeof DesaSlugDashboardAdministrasiRouteImport
      parentRoute: typeof DesaSlugDashboardRouteRoute
    }
  }
}

interface DashboardDesaRouteRouteChildren {
  DashboardDesaIndexRoute: typeof DashboardDesaIndexRoute
}

const DashboardDesaRouteRouteChildren: DashboardDesaRouteRouteChildren = {
  DashboardDesaIndexRoute: DashboardDesaIndexRoute,
}

const DashboardDesaRouteRouteWithChildren =
  DashboardDesaRouteRoute._addFileChildren(DashboardDesaRouteRouteChildren)

interface DashboardRouteRouteChildren {
  DashboardDesaRouteRoute: typeof DashboardDesaRouteRouteWithChildren
  DashboardIndexRoute: typeof DashboardIndexRoute
}

const DashboardRouteRouteChildren: DashboardRouteRouteChildren = {
  DashboardDesaRouteRoute: DashboardDesaRouteRouteWithChildren,
  DashboardIndexRoute: DashboardIndexRoute,
}

const DashboardRouteRouteWithChildren = DashboardRouteRoute._addFileChildren(
  DashboardRouteRouteChildren,
)

interface DevRouteRouteChildren {
  DevAgentSwarmRoute: typeof DevAgentSwarmRoute
  DevAiFlowRoute: typeof DevAiFlowRoute
  DevAiRoutingRoute: typeof DevAiRoutingRoute
  DevApiKeysRoute: typeof DevApiKeysRoute
  DevCodeGraphRoute: typeof DevCodeGraphRoute
  DevDbSchemaRoute: typeof DevDbSchemaRoute
  DevDocsRoute: typeof DevDocsRoute
  DevFileHealthRoute: typeof DevFileHealthRoute
  DevHandlerEvolutionRoute: typeof DevHandlerEvolutionRoute
  DevObservabilityRoute: typeof DevObservabilityRoute
  DevWaRepairBudgetRoute: typeof DevWaRepairBudgetRoute
  DevIndexRoute: typeof DevIndexRoute
}

const DevRouteRouteChildren: DevRouteRouteChildren = {
  DevAgentSwarmRoute: DevAgentSwarmRoute,
  DevAiFlowRoute: DevAiFlowRoute,
  DevAiRoutingRoute: DevAiRoutingRoute,
  DevApiKeysRoute: DevApiKeysRoute,
  DevCodeGraphRoute: DevCodeGraphRoute,
  DevDbSchemaRoute: DevDbSchemaRoute,
  DevDocsRoute: DevDocsRoute,
  DevFileHealthRoute: DevFileHealthRoute,
  DevHandlerEvolutionRoute: DevHandlerEvolutionRoute,
  DevObservabilityRoute: DevObservabilityRoute,
  DevWaRepairBudgetRoute: DevWaRepairBudgetRoute,
  DevIndexRoute: DevIndexRoute,
}

const DevRouteRouteWithChildren = DevRouteRoute._addFileChildren(
  DevRouteRouteChildren,
)

interface PlatformDesaDesaIdRouteRouteChildren {
  PlatformDesaDesaIdAdministrasiRoute: typeof PlatformDesaDesaIdAdministrasiRoute
  PlatformDesaDesaIdAgenRoute: typeof PlatformDesaDesaIdAgenRoute
  PlatformDesaDesaIdBansosRoute: typeof PlatformDesaDesaIdBansosRoute
  PlatformDesaDesaIdBencanaRoute: typeof PlatformDesaDesaIdBencanaRoute
  PlatformDesaDesaIdBookingRoute: typeof PlatformDesaDesaIdBookingRoute
  PlatformDesaDesaIdChannelRoute: typeof PlatformDesaDesaIdChannelRoute
  PlatformDesaDesaIdCustomToolsRoute: typeof PlatformDesaDesaIdCustomToolsRoute
  PlatformDesaDesaIdDokumenRoute: typeof PlatformDesaDesaIdDokumenRoute
  PlatformDesaDesaIdDraftSuratRoute: typeof PlatformDesaDesaIdDraftSuratRoute
  PlatformDesaDesaIdEkonomiRoute: typeof PlatformDesaDesaIdEkonomiRoute
  PlatformDesaDesaIdInformasiRoute: typeof PlatformDesaDesaIdInformasiRoute
  PlatformDesaDesaIdJabatanRoute: typeof PlatformDesaDesaIdJabatanRoute
  PlatformDesaDesaIdKelembagaanRoute: typeof PlatformDesaDesaIdKelembagaanRoute
  PlatformDesaDesaIdKepegawaianRoute: typeof PlatformDesaDesaIdKepegawaianRoute
  PlatformDesaDesaIdKependudukanRoute: typeof PlatformDesaDesaIdKependudukanRoute
  PlatformDesaDesaIdKepribadianAiRoute: typeof PlatformDesaDesaIdKepribadianAiRoute
  PlatformDesaDesaIdKesehatanRoute: typeof PlatformDesaDesaIdKesehatanRoute
  PlatformDesaDesaIdKetertibanRoute: typeof PlatformDesaDesaIdKetertibanRoute
  PlatformDesaDesaIdKeuanganRoute: typeof PlatformDesaDesaIdKeuanganRoute
  PlatformDesaDesaIdLaporanRoute: typeof PlatformDesaDesaIdLaporanRoute
  PlatformDesaDesaIdLifeEventsRoute: typeof PlatformDesaDesaIdLifeEventsRoute
  PlatformDesaDesaIdLogAktivitasRoute: typeof PlatformDesaDesaIdLogAktivitasRoute
  PlatformDesaDesaIdMemoryRoute: typeof PlatformDesaDesaIdMemoryRoute
  PlatformDesaDesaIdMusrenbangRoute: typeof PlatformDesaDesaIdMusrenbangRoute
  PlatformDesaDesaIdPanduanRoute: typeof PlatformDesaDesaIdPanduanRoute
  PlatformDesaDesaIdPembangunanRoute: typeof PlatformDesaDesaIdPembangunanRoute
  PlatformDesaDesaIdPemilihanRoute: typeof PlatformDesaDesaIdPemilihanRoute
  PlatformDesaDesaIdPendidikanRoute: typeof PlatformDesaDesaIdPendidikanRoute
  PlatformDesaDesaIdPengantarWilayahRoute: typeof PlatformDesaDesaIdPengantarWilayahRoute
  PlatformDesaDesaIdPengaturanRoute: typeof PlatformDesaDesaIdPengaturanRoute
  PlatformDesaDesaIdPercakapanRoute: typeof PlatformDesaDesaIdPercakapanRoute
  PlatformDesaDesaIdPertanahanRoute: typeof PlatformDesaDesaIdPertanahanRoute
  PlatformDesaDesaIdProfilDesaRoute: typeof PlatformDesaDesaIdProfilDesaRoute
  PlatformDesaDesaIdRiwayatRoute: typeof PlatformDesaDesaIdRiwayatRoute
  PlatformDesaDesaIdStaffRoute: typeof PlatformDesaDesaIdStaffRoute
  PlatformDesaDesaIdStatistikRoute: typeof PlatformDesaDesaIdStatistikRoute
  PlatformDesaDesaIdSuratRoute: typeof PlatformDesaDesaIdSuratRoute
  PlatformDesaDesaIdTemplateSuratRoute: typeof PlatformDesaDesaIdTemplateSuratRoute
  PlatformDesaDesaIdTestAiRoute: typeof PlatformDesaDesaIdTestAiRoute
  PlatformDesaDesaIdToolsRoute: typeof PlatformDesaDesaIdToolsRoute
  PlatformDesaDesaIdIndexRoute: typeof PlatformDesaDesaIdIndexRoute
}

const PlatformDesaDesaIdRouteRouteChildren: PlatformDesaDesaIdRouteRouteChildren =
  {
    PlatformDesaDesaIdAdministrasiRoute: PlatformDesaDesaIdAdministrasiRoute,
    PlatformDesaDesaIdAgenRoute: PlatformDesaDesaIdAgenRoute,
    PlatformDesaDesaIdBansosRoute: PlatformDesaDesaIdBansosRoute,
    PlatformDesaDesaIdBencanaRoute: PlatformDesaDesaIdBencanaRoute,
    PlatformDesaDesaIdBookingRoute: PlatformDesaDesaIdBookingRoute,
    PlatformDesaDesaIdChannelRoute: PlatformDesaDesaIdChannelRoute,
    PlatformDesaDesaIdCustomToolsRoute: PlatformDesaDesaIdCustomToolsRoute,
    PlatformDesaDesaIdDokumenRoute: PlatformDesaDesaIdDokumenRoute,
    PlatformDesaDesaIdDraftSuratRoute: PlatformDesaDesaIdDraftSuratRoute,
    PlatformDesaDesaIdEkonomiRoute: PlatformDesaDesaIdEkonomiRoute,
    PlatformDesaDesaIdInformasiRoute: PlatformDesaDesaIdInformasiRoute,
    PlatformDesaDesaIdJabatanRoute: PlatformDesaDesaIdJabatanRoute,
    PlatformDesaDesaIdKelembagaanRoute: PlatformDesaDesaIdKelembagaanRoute,
    PlatformDesaDesaIdKepegawaianRoute: PlatformDesaDesaIdKepegawaianRoute,
    PlatformDesaDesaIdKependudukanRoute: PlatformDesaDesaIdKependudukanRoute,
    PlatformDesaDesaIdKepribadianAiRoute: PlatformDesaDesaIdKepribadianAiRoute,
    PlatformDesaDesaIdKesehatanRoute: PlatformDesaDesaIdKesehatanRoute,
    PlatformDesaDesaIdKetertibanRoute: PlatformDesaDesaIdKetertibanRoute,
    PlatformDesaDesaIdKeuanganRoute: PlatformDesaDesaIdKeuanganRoute,
    PlatformDesaDesaIdLaporanRoute: PlatformDesaDesaIdLaporanRoute,
    PlatformDesaDesaIdLifeEventsRoute: PlatformDesaDesaIdLifeEventsRoute,
    PlatformDesaDesaIdLogAktivitasRoute: PlatformDesaDesaIdLogAktivitasRoute,
    PlatformDesaDesaIdMemoryRoute: PlatformDesaDesaIdMemoryRoute,
    PlatformDesaDesaIdMusrenbangRoute: PlatformDesaDesaIdMusrenbangRoute,
    PlatformDesaDesaIdPanduanRoute: PlatformDesaDesaIdPanduanRoute,
    PlatformDesaDesaIdPembangunanRoute: PlatformDesaDesaIdPembangunanRoute,
    PlatformDesaDesaIdPemilihanRoute: PlatformDesaDesaIdPemilihanRoute,
    PlatformDesaDesaIdPendidikanRoute: PlatformDesaDesaIdPendidikanRoute,
    PlatformDesaDesaIdPengantarWilayahRoute:
      PlatformDesaDesaIdPengantarWilayahRoute,
    PlatformDesaDesaIdPengaturanRoute: PlatformDesaDesaIdPengaturanRoute,
    PlatformDesaDesaIdPercakapanRoute: PlatformDesaDesaIdPercakapanRoute,
    PlatformDesaDesaIdPertanahanRoute: PlatformDesaDesaIdPertanahanRoute,
    PlatformDesaDesaIdProfilDesaRoute: PlatformDesaDesaIdProfilDesaRoute,
    PlatformDesaDesaIdRiwayatRoute: PlatformDesaDesaIdRiwayatRoute,
    PlatformDesaDesaIdStaffRoute: PlatformDesaDesaIdStaffRoute,
    PlatformDesaDesaIdStatistikRoute: PlatformDesaDesaIdStatistikRoute,
    PlatformDesaDesaIdSuratRoute: PlatformDesaDesaIdSuratRoute,
    PlatformDesaDesaIdTemplateSuratRoute: PlatformDesaDesaIdTemplateSuratRoute,
    PlatformDesaDesaIdTestAiRoute: PlatformDesaDesaIdTestAiRoute,
    PlatformDesaDesaIdToolsRoute: PlatformDesaDesaIdToolsRoute,
    PlatformDesaDesaIdIndexRoute: PlatformDesaDesaIdIndexRoute,
  }

const PlatformDesaDesaIdRouteRouteWithChildren =
  PlatformDesaDesaIdRouteRoute._addFileChildren(
    PlatformDesaDesaIdRouteRouteChildren,
  )

interface PlatformDesaRouteRouteChildren {
  PlatformDesaDesaIdRouteRoute: typeof PlatformDesaDesaIdRouteRouteWithChildren
  PlatformDesaIndexRoute: typeof PlatformDesaIndexRoute
}

const PlatformDesaRouteRouteChildren: PlatformDesaRouteRouteChildren = {
  PlatformDesaDesaIdRouteRoute: PlatformDesaDesaIdRouteRouteWithChildren,
  PlatformDesaIndexRoute: PlatformDesaIndexRoute,
}

const PlatformDesaRouteRouteWithChildren =
  PlatformDesaRouteRoute._addFileChildren(PlatformDesaRouteRouteChildren)

interface PlatformRouteRouteChildren {
  PlatformDesaRouteRoute: typeof PlatformDesaRouteRouteWithChildren
  PlatformIntegrasiDesaRoute: typeof PlatformIntegrasiDesaRoute
  PlatformLogAktivitasRoute: typeof PlatformLogAktivitasRoute
  PlatformPanduanRoute: typeof PlatformPanduanRoute
  PlatformPengaturanRoute: typeof PlatformPengaturanRoute
  PlatformPenggunaRoute: typeof PlatformPenggunaRoute
  PlatformTiketRoute: typeof PlatformTiketRoute
  PlatformWhatsappServerRoute: typeof PlatformWhatsappServerRoute
  PlatformWorkersRoute: typeof PlatformWorkersRoute
  PlatformIndexRoute: typeof PlatformIndexRoute
}

const PlatformRouteRouteChildren: PlatformRouteRouteChildren = {
  PlatformDesaRouteRoute: PlatformDesaRouteRouteWithChildren,
  PlatformIntegrasiDesaRoute: PlatformIntegrasiDesaRoute,
  PlatformLogAktivitasRoute: PlatformLogAktivitasRoute,
  PlatformPanduanRoute: PlatformPanduanRoute,
  PlatformPengaturanRoute: PlatformPengaturanRoute,
  PlatformPenggunaRoute: PlatformPenggunaRoute,
  PlatformTiketRoute: PlatformTiketRoute,
  PlatformWhatsappServerRoute: PlatformWhatsappServerRoute,
  PlatformWorkersRoute: PlatformWorkersRoute,
  PlatformIndexRoute: PlatformIndexRoute,
}

const PlatformRouteRouteWithChildren = PlatformRouteRoute._addFileChildren(
  PlatformRouteRouteChildren,
)

interface DesaSlugDashboardRouteRouteChildren {
  DesaSlugDashboardAdministrasiRoute: typeof DesaSlugDashboardAdministrasiRoute
  DesaSlugDashboardAgenRoute: typeof DesaSlugDashboardAgenRoute
  DesaSlugDashboardBansosRoute: typeof DesaSlugDashboardBansosRoute
  DesaSlugDashboardBencanaRoute: typeof DesaSlugDashboardBencanaRoute
  DesaSlugDashboardBookingRoute: typeof DesaSlugDashboardBookingRoute
  DesaSlugDashboardChannelRoute: typeof DesaSlugDashboardChannelRoute
  DesaSlugDashboardCustomToolsRoute: typeof DesaSlugDashboardCustomToolsRoute
  DesaSlugDashboardDokumenRoute: typeof DesaSlugDashboardDokumenRoute
  DesaSlugDashboardDraftSuratRoute: typeof DesaSlugDashboardDraftSuratRoute
  DesaSlugDashboardEkonomiRoute: typeof DesaSlugDashboardEkonomiRoute
  DesaSlugDashboardInformasiRoute: typeof DesaSlugDashboardInformasiRoute
  DesaSlugDashboardJabatanRoute: typeof DesaSlugDashboardJabatanRoute
  DesaSlugDashboardKelembagaanRoute: typeof DesaSlugDashboardKelembagaanRoute
  DesaSlugDashboardKepegawaianRoute: typeof DesaSlugDashboardKepegawaianRoute
  DesaSlugDashboardKependudukanRoute: typeof DesaSlugDashboardKependudukanRoute
  DesaSlugDashboardKepribadianAiRoute: typeof DesaSlugDashboardKepribadianAiRoute
  DesaSlugDashboardKesehatanRoute: typeof DesaSlugDashboardKesehatanRoute
  DesaSlugDashboardKetertibanRoute: typeof DesaSlugDashboardKetertibanRoute
  DesaSlugDashboardKeuanganRoute: typeof DesaSlugDashboardKeuanganRoute
  DesaSlugDashboardLaporanRoute: typeof DesaSlugDashboardLaporanRoute
  DesaSlugDashboardLifeEventsRoute: typeof DesaSlugDashboardLifeEventsRoute
  DesaSlugDashboardLogAktivitasRoute: typeof DesaSlugDashboardLogAktivitasRoute
  DesaSlugDashboardMemoryRoute: typeof DesaSlugDashboardMemoryRoute
  DesaSlugDashboardMusrenbangRoute: typeof DesaSlugDashboardMusrenbangRoute
  DesaSlugDashboardPanduanRoute: typeof DesaSlugDashboardPanduanRoute
  DesaSlugDashboardPembangunanRoute: typeof DesaSlugDashboardPembangunanRoute
  DesaSlugDashboardPemilihanRoute: typeof DesaSlugDashboardPemilihanRoute
  DesaSlugDashboardPendidikanRoute: typeof DesaSlugDashboardPendidikanRoute
  DesaSlugDashboardPengantarWilayahRoute: typeof DesaSlugDashboardPengantarWilayahRoute
  DesaSlugDashboardPengaturanRoute: typeof DesaSlugDashboardPengaturanRoute
  DesaSlugDashboardPercakapanRoute: typeof DesaSlugDashboardPercakapanRoute
  DesaSlugDashboardPertanahanRoute: typeof DesaSlugDashboardPertanahanRoute
  DesaSlugDashboardProfilDesaRoute: typeof DesaSlugDashboardProfilDesaRoute
  DesaSlugDashboardRiwayatRoute: typeof DesaSlugDashboardRiwayatRoute
  DesaSlugDashboardStaffRoute: typeof DesaSlugDashboardStaffRoute
  DesaSlugDashboardStatistikRoute: typeof DesaSlugDashboardStatistikRoute
  DesaSlugDashboardSuratRoute: typeof DesaSlugDashboardSuratRoute
  DesaSlugDashboardTemplateSuratRoute: typeof DesaSlugDashboardTemplateSuratRoute
  DesaSlugDashboardTestAiRoute: typeof DesaSlugDashboardTestAiRoute
  DesaSlugDashboardToolsRoute: typeof DesaSlugDashboardToolsRoute
  DesaSlugDashboardIndexRoute: typeof DesaSlugDashboardIndexRoute
}

const DesaSlugDashboardRouteRouteChildren: DesaSlugDashboardRouteRouteChildren =
  {
    DesaSlugDashboardAdministrasiRoute: DesaSlugDashboardAdministrasiRoute,
    DesaSlugDashboardAgenRoute: DesaSlugDashboardAgenRoute,
    DesaSlugDashboardBansosRoute: DesaSlugDashboardBansosRoute,
    DesaSlugDashboardBencanaRoute: DesaSlugDashboardBencanaRoute,
    DesaSlugDashboardBookingRoute: DesaSlugDashboardBookingRoute,
    DesaSlugDashboardChannelRoute: DesaSlugDashboardChannelRoute,
    DesaSlugDashboardCustomToolsRoute: DesaSlugDashboardCustomToolsRoute,
    DesaSlugDashboardDokumenRoute: DesaSlugDashboardDokumenRoute,
    DesaSlugDashboardDraftSuratRoute: DesaSlugDashboardDraftSuratRoute,
    DesaSlugDashboardEkonomiRoute: DesaSlugDashboardEkonomiRoute,
    DesaSlugDashboardInformasiRoute: DesaSlugDashboardInformasiRoute,
    DesaSlugDashboardJabatanRoute: DesaSlugDashboardJabatanRoute,
    DesaSlugDashboardKelembagaanRoute: DesaSlugDashboardKelembagaanRoute,
    DesaSlugDashboardKepegawaianRoute: DesaSlugDashboardKepegawaianRoute,
    DesaSlugDashboardKependudukanRoute: DesaSlugDashboardKependudukanRoute,
    DesaSlugDashboardKepribadianAiRoute: DesaSlugDashboardKepribadianAiRoute,
    DesaSlugDashboardKesehatanRoute: DesaSlugDashboardKesehatanRoute,
    DesaSlugDashboardKetertibanRoute: DesaSlugDashboardKetertibanRoute,
    DesaSlugDashboardKeuanganRoute: DesaSlugDashboardKeuanganRoute,
    DesaSlugDashboardLaporanRoute: DesaSlugDashboardLaporanRoute,
    DesaSlugDashboardLifeEventsRoute: DesaSlugDashboardLifeEventsRoute,
    DesaSlugDashboardLogAktivitasRoute: DesaSlugDashboardLogAktivitasRoute,
    DesaSlugDashboardMemoryRoute: DesaSlugDashboardMemoryRoute,
    DesaSlugDashboardMusrenbangRoute: DesaSlugDashboardMusrenbangRoute,
    DesaSlugDashboardPanduanRoute: DesaSlugDashboardPanduanRoute,
    DesaSlugDashboardPembangunanRoute: DesaSlugDashboardPembangunanRoute,
    DesaSlugDashboardPemilihanRoute: DesaSlugDashboardPemilihanRoute,
    DesaSlugDashboardPendidikanRoute: DesaSlugDashboardPendidikanRoute,
    DesaSlugDashboardPengantarWilayahRoute:
      DesaSlugDashboardPengantarWilayahRoute,
    DesaSlugDashboardPengaturanRoute: DesaSlugDashboardPengaturanRoute,
    DesaSlugDashboardPercakapanRoute: DesaSlugDashboardPercakapanRoute,
    DesaSlugDashboardPertanahanRoute: DesaSlugDashboardPertanahanRoute,
    DesaSlugDashboardProfilDesaRoute: DesaSlugDashboardProfilDesaRoute,
    DesaSlugDashboardRiwayatRoute: DesaSlugDashboardRiwayatRoute,
    DesaSlugDashboardStaffRoute: DesaSlugDashboardStaffRoute,
    DesaSlugDashboardStatistikRoute: DesaSlugDashboardStatistikRoute,
    DesaSlugDashboardSuratRoute: DesaSlugDashboardSuratRoute,
    DesaSlugDashboardTemplateSuratRoute: DesaSlugDashboardTemplateSuratRoute,
    DesaSlugDashboardTestAiRoute: DesaSlugDashboardTestAiRoute,
    DesaSlugDashboardToolsRoute: DesaSlugDashboardToolsRoute,
    DesaSlugDashboardIndexRoute: DesaSlugDashboardIndexRoute,
  }

const DesaSlugDashboardRouteRouteWithChildren =
  DesaSlugDashboardRouteRoute._addFileChildren(
    DesaSlugDashboardRouteRouteChildren,
  )

interface DesaSlugLaporanRouteRouteChildren {
  DesaSlugLaporanIdRoute: typeof DesaSlugLaporanIdRoute
  DesaSlugLaporanIndexRoute: typeof DesaSlugLaporanIndexRoute
}

const DesaSlugLaporanRouteRouteChildren: DesaSlugLaporanRouteRouteChildren = {
  DesaSlugLaporanIdRoute: DesaSlugLaporanIdRoute,
  DesaSlugLaporanIndexRoute: DesaSlugLaporanIndexRoute,
}

const DesaSlugLaporanRouteRouteWithChildren =
  DesaSlugLaporanRouteRoute._addFileChildren(DesaSlugLaporanRouteRouteChildren)

interface DesaSlugWargaRouteRouteChildren {
  DesaSlugWargaBookingRoute: typeof DesaSlugWargaBookingRoute
  DesaSlugWargaChatRoute: typeof DesaSlugWargaChatRoute
  DesaSlugWargaLaporanRoute: typeof DesaSlugWargaLaporanRoute
  DesaSlugWargaLifeEventsRoute: typeof DesaSlugWargaLifeEventsRoute
  DesaSlugWargaLoginRoute: typeof DesaSlugWargaLoginRoute
  DesaSlugWargaProfilRoute: typeof DesaSlugWargaProfilRoute
  DesaSlugWargaSuratRoute: typeof DesaSlugWargaSuratRoute
  DesaSlugWargaIndexRoute: typeof DesaSlugWargaIndexRoute
}

const DesaSlugWargaRouteRouteChildren: DesaSlugWargaRouteRouteChildren = {
  DesaSlugWargaBookingRoute: DesaSlugWargaBookingRoute,
  DesaSlugWargaChatRoute: DesaSlugWargaChatRoute,
  DesaSlugWargaLaporanRoute: DesaSlugWargaLaporanRoute,
  DesaSlugWargaLifeEventsRoute: DesaSlugWargaLifeEventsRoute,
  DesaSlugWargaLoginRoute: DesaSlugWargaLoginRoute,
  DesaSlugWargaProfilRoute: DesaSlugWargaProfilRoute,
  DesaSlugWargaSuratRoute: DesaSlugWargaSuratRoute,
  DesaSlugWargaIndexRoute: DesaSlugWargaIndexRoute,
}

const DesaSlugWargaRouteRouteWithChildren =
  DesaSlugWargaRouteRoute._addFileChildren(DesaSlugWargaRouteRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  DashboardRouteRoute: DashboardRouteRouteWithChildren,
  DevRouteRoute: DevRouteRouteWithChildren,
  PlatformRouteRoute: PlatformRouteRouteWithChildren,
  StaffRouteRoute: StaffRouteRoute,
  CompleteProfileRoute: CompleteProfileRoute,
  LoginRoute: LoginRoute,
  NarasiRoute: NarasiRoute,
  ParkirRoute: ParkirRoute,
  PilihDesaRoute: PilihDesaRoute,
  PrivasiRoute: PrivasiRoute,
  TaskInventoryRoute: TaskInventoryRoute,
  WargaSlugRouteRoute: WargaSlugRouteRoute,
  VerifyKodeRoute: VerifyKodeRoute,
  WargaPilihDesaRoute: WargaPilihDesaRoute,
  DesaSlugDashboardRouteRoute: DesaSlugDashboardRouteRouteWithChildren,
  DesaSlugLaporanRouteRoute: DesaSlugLaporanRouteRouteWithChildren,
  DesaSlugWargaRouteRoute: DesaSlugWargaRouteRouteWithChildren,
  DesaSlugBookingRoute: DesaSlugBookingRoute,
  DesaSlugOverviewRoute: DesaSlugOverviewRoute,
  DesaSlugTransparansiRoute: DesaSlugTransparansiRoute,
  DesaSlugVerifikasiKtpRoute: DesaSlugVerifikasiKtpRoute,
  DesaSlugIndexRoute: DesaSlugIndexRoute,
  DesaSlugFormKodeRoute: DesaSlugFormKodeRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
